import { ref as xe, onMounted as _t, onBeforeUnmount as nn, defineComponent as Nt, nextTick as AB, openBlock as JA, createElementBlock as XA, renderSlot as eB, reactive as tB, computed as QA, shallowReactive as sn, toRefs as on, normalizeStyle as rr, unref as st, Fragment as Qn, renderList as an, createElementVNode as cn, mergeProps as gn, toDisplayString as wn } from "vue";
function rB(A) {
  return A.install = (e) => {
    e.component(A.name, A);
  }, A;
}
var ot = null;
function Un(A) {
  return ot || (ot = (window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function(e) {
    return setTimeout(e, 16);
  }).bind(window)), ot(A);
}
var it = null;
function un(A) {
  it || (it = (window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || function(e) {
    clearTimeout(e);
  }).bind(window)), it(A);
}
function Cn(A) {
  var e = document.createElement("style");
  return e.styleSheet ? e.styleSheet.cssText = A : e.appendChild(document.createTextNode(A)), (document.querySelector("head") || document.body).appendChild(e), e;
}
function oe(A, e) {
  e === void 0 && (e = {});
  var r = document.createElement(A);
  return Object.keys(e).forEach(function(t) {
    r[t] = e[t];
  }), r;
}
function BB(A, e, r) {
  var t = window.getComputedStyle(A, null) || {
    display: "none"
  };
  return t[e];
}
function Kt(A) {
  if (!document.documentElement.contains(A))
    return {
      detached: !0,
      rendered: !1
    };
  for (var e = A; e !== document; ) {
    if (BB(e, "display") === "none")
      return {
        detached: !1,
        rendered: !1
      };
    e = e.parentNode;
  }
  return {
    detached: !1,
    rendered: !0
  };
}
var ln = '.resize-triggers{visibility:hidden;opacity:0;pointer-events:none}.resize-contract-trigger,.resize-contract-trigger:before,.resize-expand-trigger,.resize-triggers{content:"";position:absolute;top:0;left:0;height:100%;width:100%;overflow:hidden}.resize-contract-trigger,.resize-expand-trigger{background:#eee;overflow:auto}.resize-contract-trigger:before{width:200%;height:200%}', mt = 0, be = null;
function Fn(A, e) {
  A.__resize_mutation_handler__ || (A.__resize_mutation_handler__ = fn.bind(A));
  var r = A.__resize_listeners__;
  if (!r) {
    if (A.__resize_listeners__ = [], window.ResizeObserver) {
      var t = A.offsetWidth, B = A.offsetHeight, n = new ResizeObserver(function() {
        !A.__resize_observer_triggered__ && (A.__resize_observer_triggered__ = !0, A.offsetWidth === t && A.offsetHeight === B) || Se(A);
      }), s = Kt(A), o = s.detached, i = s.rendered;
      A.__resize_observer_triggered__ = o === !1 && i === !1, A.__resize_observer__ = n, n.observe(A);
    } else if (A.attachEvent && A.addEventListener)
      A.__resize_legacy_resize_handler__ = function() {
        Se(A);
      }, A.attachEvent("onresize", A.__resize_legacy_resize_handler__), document.addEventListener("DOMSubtreeModified", A.__resize_mutation_handler__);
    else if (mt || (be = Cn(ln)), Hn(A), A.__resize_rendered__ = Kt(A).rendered, window.MutationObserver) {
      var Q = new MutationObserver(A.__resize_mutation_handler__);
      Q.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      }), A.__resize_mutation_observer__ = Q;
    }
  }
  A.__resize_listeners__.push(e), mt++;
}
function hn(A, e) {
  var r = A.__resize_listeners__;
  if (r) {
    if (r.splice(r.indexOf(e), 1), !r.length || !e) {
      if (A.detachEvent && A.removeEventListener) {
        A.detachEvent("onresize", A.__resize_legacy_resize_handler__), document.removeEventListener("DOMSubtreeModified", A.__resize_mutation_handler__);
        return;
      }
      A.__resize_observer__ ? (A.__resize_observer__.unobserve(A), A.__resize_observer__.disconnect(), A.__resize_observer__ = null) : (A.__resize_mutation_observer__ && (A.__resize_mutation_observer__.disconnect(), A.__resize_mutation_observer__ = null), A.removeEventListener("scroll", Yt), A.removeChild(A.__resize_triggers__.triggers), A.__resize_triggers__ = null), A.__resize_listeners__ = null;
    }
    !--mt && be && be.parentNode.removeChild(be);
  }
}
function dn(A) {
  var e = A.__resize_last__, r = e.width, t = e.height, B = A.offsetWidth, n = A.offsetHeight;
  return B !== r || n !== t ? {
    width: B,
    height: n
  } : null;
}
function fn() {
  var A = Kt(this), e = A.rendered, r = A.detached;
  e !== this.__resize_rendered__ && (!r && this.__resize_triggers__ && (Wt(this), this.addEventListener("scroll", Yt, !0)), this.__resize_rendered__ = e, Se(this));
}
function Yt() {
  var A = this;
  Wt(this), this.__resize_raf__ && un(this.__resize_raf__), this.__resize_raf__ = Un(function() {
    var e = dn(A);
    e && (A.__resize_last__ = e, Se(A));
  });
}
function Se(A) {
  !A || !A.__resize_listeners__ || A.__resize_listeners__.forEach(function(e) {
    e.call(A, A);
  });
}
function Hn(A) {
  var e = BB(A, "position");
  (!e || e === "static") && (A.style.position = "relative"), A.__resize_old_position__ = e, A.__resize_last__ = {};
  var r = oe("div", {
    className: "resize-triggers"
  }), t = oe("div", {
    className: "resize-expand-trigger"
  }), B = oe("div"), n = oe("div", {
    className: "resize-contract-trigger"
  });
  t.appendChild(B), r.appendChild(t), r.appendChild(n), A.appendChild(r), A.__resize_triggers__ = {
    triggers: r,
    expand: t,
    expandChild: B,
    contract: n
  }, Wt(A), A.addEventListener("scroll", Yt, !0), A.__resize_last__ = {
    width: A.offsetWidth,
    height: A.offsetHeight
  };
}
function Wt(A) {
  var e = A.__resize_triggers__, r = e.expand, t = e.expandChild, B = e.contract, n = B.scrollWidth, s = B.scrollHeight, o = r.offsetWidth, i = r.offsetHeight, Q = r.scrollWidth, a = r.scrollHeight;
  B.scrollLeft = n, B.scrollTop = s, t.style.width = o + 1 + "px", t.style.height = i + 1 + "px", r.scrollLeft = Q, r.scrollTop = a;
}
function pn(A) {
  const e = xe();
  return _t(function() {
    e.value && Fn(e.value, A);
  }), nn(function() {
    e.value && hn(e.value, A);
  }), { el: e };
}
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Lt = function(A, e) {
  return Lt = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, t) {
    r.__proto__ = t;
  } || function(r, t) {
    for (var B in t) Object.prototype.hasOwnProperty.call(t, B) && (r[B] = t[B]);
  }, Lt(A, e);
};
function tA(A, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  Lt(A, e);
  function r() {
    this.constructor = A;
  }
  A.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
}
function z(A, e, r, t) {
  function B(n) {
    return n instanceof r ? n : new r(function(s) {
      s(n);
    });
  }
  return new (r || (r = Promise))(function(n, s) {
    function o(a) {
      try {
        Q(t.next(a));
      } catch (c) {
        s(c);
      }
    }
    function i(a) {
      try {
        Q(t.throw(a));
      } catch (c) {
        s(c);
      }
    }
    function Q(a) {
      a.done ? n(a.value) : B(a.value).then(o, i);
    }
    Q((t = t.apply(A, [])).next());
  });
}
function N(A, e) {
  var r = { label: 0, sent: function() {
    if (n[0] & 1) throw n[1];
    return n[1];
  }, trys: [], ops: [] }, t, B, n, s;
  return s = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function o(Q) {
    return function(a) {
      return i([Q, a]);
    };
  }
  function i(Q) {
    if (t) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (t = 1, B && (n = Q[0] & 2 ? B.return : Q[0] ? B.throw || ((n = B.return) && n.call(B), 0) : B.next) && !(n = n.call(B, Q[1])).done) return n;
      switch (B = 0, n && (Q = [Q[0] & 2, n.value]), Q[0]) {
        case 0:
        case 1:
          n = Q;
          break;
        case 4:
          return r.label++, { value: Q[1], done: !1 };
        case 5:
          r.label++, B = Q[1], Q = [0];
          continue;
        case 7:
          Q = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (n = r.trys, !(n = n.length > 0 && n[n.length - 1]) && (Q[0] === 6 || Q[0] === 2)) {
            r = 0;
            continue;
          }
          if (Q[0] === 3 && (!n || Q[1] > n[0] && Q[1] < n[3])) {
            r.label = Q[1];
            break;
          }
          if (Q[0] === 6 && r.label < n[1]) {
            r.label = n[1], n = Q;
            break;
          }
          if (n && r.label < n[2]) {
            r.label = n[2], r.ops.push(Q);
            break;
          }
          n[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      Q = e.call(A, r);
    } catch (a) {
      Q = [6, a], B = 0;
    } finally {
      t = n = 0;
    }
    if (Q[0] & 5) throw Q[1];
    return { value: Q[0] ? Q[1] : void 0, done: !0 };
  }
}
var pA = (
  /** @class */
  function() {
    function A(e, r, t, B) {
      this.left = e, this.top = r, this.width = t, this.height = B;
    }
    return A.prototype.add = function(e, r, t, B) {
      return new A(this.left + e, this.top + r, this.width + t, this.height + B);
    }, A.fromClientRect = function(e, r) {
      return new A(r.left + e.windowBounds.left, r.top + e.windowBounds.top, r.width, r.height);
    }, A.fromDOMRectList = function(e, r) {
      var t = Array.from(r).find(function(B) {
        return B.width !== 0;
      });
      return t ? new A(t.left + e.windowBounds.left, t.top + e.windowBounds.top, t.width, t.height) : A.EMPTY;
    }, A.EMPTY = new A(0, 0, 0, 0), A;
  }()
), Zt = function(A, e) {
  return pA.fromClientRect(A, e.getBoundingClientRect());
}, Xe = function(A) {
  for (var e = [], r = 0, t = A.length; r < t; ) {
    var B = A.charCodeAt(r++);
    if (B >= 55296 && B <= 56319 && r < t) {
      var n = A.charCodeAt(r++);
      (n & 64512) === 56320 ? e.push(((B & 1023) << 10) + (n & 1023) + 65536) : (e.push(B), r--);
    } else
      e.push(B);
  }
  return e;
}, x = function() {
  for (var A = [], e = 0; e < arguments.length; e++)
    A[e] = arguments[e];
  if (String.fromCodePoint)
    return String.fromCodePoint.apply(String, A);
  var r = A.length;
  if (!r)
    return "";
  for (var t = [], B = -1, n = ""; ++B < r; ) {
    var s = A[B];
    s <= 65535 ? t.push(s) : (s -= 65536, t.push((s >> 10) + 55296, s % 1024 + 56320)), (B + 1 === r || t.length > 16384) && (n += String.fromCharCode.apply(String, t), t.length = 0);
  }
  return n;
}, Br = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", En = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var ie = 0; ie < Br.length; ie++)
  En[Br.charCodeAt(ie)] = ie;
var nr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", _A = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Qe = 0; Qe < nr.length; Qe++)
  _A[nr.charCodeAt(Qe)] = Qe;
var In = function(A) {
  var e = A.length * 0.75, r = A.length, t, B = 0, n, s, o, i;
  A[A.length - 1] === "=" && (e--, A[A.length - 2] === "=" && e--);
  var Q = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && typeof Uint8Array.prototype.slice < "u" ? new ArrayBuffer(e) : new Array(e), a = Array.isArray(Q) ? Q : new Uint8Array(Q);
  for (t = 0; t < r; t += 4)
    n = _A[A.charCodeAt(t)], s = _A[A.charCodeAt(t + 1)], o = _A[A.charCodeAt(t + 2)], i = _A[A.charCodeAt(t + 3)], a[B++] = n << 2 | s >> 4, a[B++] = (s & 15) << 4 | o >> 2, a[B++] = (o & 3) << 6 | i & 63;
  return Q;
}, yn = function(A) {
  for (var e = A.length, r = [], t = 0; t < e; t += 2)
    r.push(A[t + 1] << 8 | A[t]);
  return r;
}, Kn = function(A) {
  for (var e = A.length, r = [], t = 0; t < e; t += 4)
    r.push(A[t + 3] << 24 | A[t + 2] << 16 | A[t + 1] << 8 | A[t]);
  return r;
}, fA = 5, zt = 11, Qt = 2, mn = zt - fA, nB = 65536 >> fA, Ln = 1 << fA, at = Ln - 1, bn = 1024 >> fA, Dn = nB + bn, vn = Dn, Mn = 32, xn = vn + Mn, Sn = 65536 >> zt, Gn = 1 << mn, Tn = Gn - 1, sr = function(A, e, r) {
  return A.slice ? A.slice(e, r) : new Uint16Array(Array.prototype.slice.call(A, e, r));
}, On = function(A, e, r) {
  return A.slice ? A.slice(e, r) : new Uint32Array(Array.prototype.slice.call(A, e, r));
}, Vn = function(A, e) {
  var r = In(A), t = Array.isArray(r) ? Kn(r) : new Uint32Array(r), B = Array.isArray(r) ? yn(r) : new Uint16Array(r), n = 24, s = sr(B, n / 2, t[4] / 2), o = t[5] === 2 ? sr(B, (n + t[4]) / 2) : On(t, Math.ceil((n + t[4]) / 4));
  return new kn(t[0], t[1], t[2], t[3], s, o);
}, kn = (
  /** @class */
  function() {
    function A(e, r, t, B, n, s) {
      this.initialValue = e, this.errorValue = r, this.highStart = t, this.highValueIndex = B, this.index = n, this.data = s;
    }
    return A.prototype.get = function(e) {
      var r;
      if (e >= 0) {
        if (e < 55296 || e > 56319 && e <= 65535)
          return r = this.index[e >> fA], r = (r << Qt) + (e & at), this.data[r];
        if (e <= 65535)
          return r = this.index[nB + (e - 55296 >> fA)], r = (r << Qt) + (e & at), this.data[r];
        if (e < this.highStart)
          return r = xn - Sn + (e >> zt), r = this.index[r], r += e >> fA & Tn, r = this.index[r], r = (r << Qt) + (e & at), this.data[r];
        if (e <= 1114111)
          return this.data[this.highValueIndex];
      }
      return this.errorValue;
    }, A;
  }()
), or = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Rn = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var ae = 0; ae < or.length; ae++)
  Rn[or.charCodeAt(ae)] = ae;
var Pn = "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", ir = 50, Jn = 1, sB = 2, oB = 3, Xn = 4, _n = 5, Qr = 7, iB = 8, ar = 9, wA = 10, bt = 11, cr = 12, Dt = 13, Nn = 14, NA = 15, vt = 16, ce = 17, VA = 18, Yn = 19, gr = 20, Mt = 21, kA = 22, ct = 23, yA = 24, Y = 25, YA = 26, WA = 27, KA = 28, Wn = 29, xA = 30, Zn = 31, ge = 32, we = 33, xt = 34, St = 35, Gt = 36, ee = 37, Tt = 38, De = 39, ve = 40, gt = 41, QB = 42, zn = 43, qn = [9001, 65288], aB = "!", P = "×", Ue = "÷", Ot = Vn(Pn), oA = [xA, Gt], Vt = [Jn, sB, oB, _n], cB = [wA, iB], wr = [WA, YA], jn = Vt.concat(cB), Ur = [Tt, De, ve, xt, St], $n = [NA, Dt], As = function(A, e) {
  e === void 0 && (e = "strict");
  var r = [], t = [], B = [];
  return A.forEach(function(n, s) {
    var o = Ot.get(n);
    if (o > ir ? (B.push(!0), o -= ir) : B.push(!1), ["normal", "auto", "loose"].indexOf(e) !== -1 && [8208, 8211, 12316, 12448].indexOf(n) !== -1)
      return t.push(s), r.push(vt);
    if (o === Xn || o === bt) {
      if (s === 0)
        return t.push(s), r.push(xA);
      var i = r[s - 1];
      return jn.indexOf(i) === -1 ? (t.push(t[s - 1]), r.push(i)) : (t.push(s), r.push(xA));
    }
    if (t.push(s), o === Zn)
      return r.push(e === "strict" ? Mt : ee);
    if (o === QB || o === Wn)
      return r.push(xA);
    if (o === zn)
      return n >= 131072 && n <= 196605 || n >= 196608 && n <= 262141 ? r.push(ee) : r.push(xA);
    r.push(o);
  }), [t, r, B];
}, wt = function(A, e, r, t) {
  var B = t[r];
  if (Array.isArray(A) ? A.indexOf(B) !== -1 : A === B)
    for (var n = r; n <= t.length; ) {
      n++;
      var s = t[n];
      if (s === e)
        return !0;
      if (s !== wA)
        break;
    }
  if (B === wA)
    for (var n = r; n > 0; ) {
      n--;
      var o = t[n];
      if (Array.isArray(A) ? A.indexOf(o) !== -1 : A === o)
        for (var i = r; i <= t.length; ) {
          i++;
          var s = t[i];
          if (s === e)
            return !0;
          if (s !== wA)
            break;
        }
      if (o !== wA)
        break;
    }
  return !1;
}, ur = function(A, e) {
  for (var r = A; r >= 0; ) {
    var t = e[r];
    if (t === wA)
      r--;
    else
      return t;
  }
  return 0;
}, es = function(A, e, r, t, B) {
  if (r[t] === 0)
    return P;
  var n = t - 1;
  if (Array.isArray(B) && B[n] === !0)
    return P;
  var s = n - 1, o = n + 1, i = e[n], Q = s >= 0 ? e[s] : 0, a = e[o];
  if (i === sB && a === oB)
    return P;
  if (Vt.indexOf(i) !== -1)
    return aB;
  if (Vt.indexOf(a) !== -1 || cB.indexOf(a) !== -1)
    return P;
  if (ur(n, e) === iB)
    return Ue;
  if (Ot.get(A[n]) === bt || (i === ge || i === we) && Ot.get(A[o]) === bt || i === Qr || a === Qr || i === ar || [wA, Dt, NA].indexOf(i) === -1 && a === ar || [ce, VA, Yn, yA, KA].indexOf(a) !== -1 || ur(n, e) === kA || wt(ct, kA, n, e) || wt([ce, VA], Mt, n, e) || wt(cr, cr, n, e))
    return P;
  if (i === wA)
    return Ue;
  if (i === ct || a === ct)
    return P;
  if (a === vt || i === vt)
    return Ue;
  if ([Dt, NA, Mt].indexOf(a) !== -1 || i === Nn || Q === Gt && $n.indexOf(i) !== -1 || i === KA && a === Gt || a === gr || oA.indexOf(a) !== -1 && i === Y || oA.indexOf(i) !== -1 && a === Y || i === WA && [ee, ge, we].indexOf(a) !== -1 || [ee, ge, we].indexOf(i) !== -1 && a === YA || oA.indexOf(i) !== -1 && wr.indexOf(a) !== -1 || wr.indexOf(i) !== -1 && oA.indexOf(a) !== -1 || // (PR | PO) × ( OP | HY )? NU
  [WA, YA].indexOf(i) !== -1 && (a === Y || [kA, NA].indexOf(a) !== -1 && e[o + 1] === Y) || // ( OP | HY ) × NU
  [kA, NA].indexOf(i) !== -1 && a === Y || // NU ×	(NU | SY | IS)
  i === Y && [Y, KA, yA].indexOf(a) !== -1)
    return P;
  if ([Y, KA, yA, ce, VA].indexOf(a) !== -1)
    for (var c = n; c >= 0; ) {
      var g = e[c];
      if (g === Y)
        return P;
      if ([KA, yA].indexOf(g) !== -1)
        c--;
      else
        break;
    }
  if ([WA, YA].indexOf(a) !== -1)
    for (var c = [ce, VA].indexOf(i) !== -1 ? s : n; c >= 0; ) {
      var g = e[c];
      if (g === Y)
        return P;
      if ([KA, yA].indexOf(g) !== -1)
        c--;
      else
        break;
    }
  if (Tt === i && [Tt, De, xt, St].indexOf(a) !== -1 || [De, xt].indexOf(i) !== -1 && [De, ve].indexOf(a) !== -1 || [ve, St].indexOf(i) !== -1 && a === ve || Ur.indexOf(i) !== -1 && [gr, YA].indexOf(a) !== -1 || Ur.indexOf(a) !== -1 && i === WA || oA.indexOf(i) !== -1 && oA.indexOf(a) !== -1 || i === yA && oA.indexOf(a) !== -1 || oA.concat(Y).indexOf(i) !== -1 && a === kA && qn.indexOf(A[o]) === -1 || oA.concat(Y).indexOf(a) !== -1 && i === VA)
    return P;
  if (i === gt && a === gt) {
    for (var U = r[n], w = 1; U > 0 && (U--, e[U] === gt); )
      w++;
    if (w % 2 !== 0)
      return P;
  }
  return i === ge && a === we ? P : Ue;
}, ts = function(A, e) {
  var r = As(A, e.lineBreak), t = r[0], B = r[1], n = r[2];
  (e.wordBreak === "break-all" || e.wordBreak === "break-word") && (B = B.map(function(o) {
    return [Y, xA, QB].indexOf(o) !== -1 ? ee : o;
  }));
  var s = e.wordBreak === "keep-all" ? n.map(function(o, i) {
    return o && A[i] >= 19968 && A[i] <= 40959;
  }) : void 0;
  return [t, B, s];
}, rs = (
  /** @class */
  function() {
    function A(e, r, t, B) {
      this.codePoints = e, this.required = r === aB, this.start = t, this.end = B;
    }
    return A.prototype.slice = function() {
      return x.apply(void 0, this.codePoints.slice(this.start, this.end));
    }, A;
  }()
), Bs = function(A, e) {
  var r = Xe(A), t = ts(r, e), B = t[0], n = t[1], s = t[2], o = r.length, i = 0, Q = 0;
  return {
    next: function() {
      if (Q >= o)
        return { done: !0, value: null };
      for (var a = P; Q < o && (a = es(r, n, B, ++Q, s)) === P; )
        ;
      if (a !== P || Q === o) {
        var c = new rs(r, a, i, Q);
        return i = Q, { value: c, done: !1 };
      }
      return { done: !0, value: null };
    }
  };
}, ns = 1, ss = 2, Be = 4, Cr = 8, Ge = 10, lr = 47, jA = 92, os = 9, is = 32, ue = 34, RA = 61, Qs = 35, as = 36, cs = 37, Ce = 39, le = 40, PA = 41, gs = 95, _ = 45, ws = 33, Us = 60, us = 62, Cs = 64, ls = 91, Fs = 93, hs = 61, ds = 123, Fe = 63, fs = 125, Fr = 124, Hs = 126, ps = 128, hr = 65533, Ut = 42, hA = 43, Es = 44, Is = 58, ys = 59, te = 46, Ks = 0, ms = 8, Ls = 11, bs = 14, Ds = 31, vs = 127, rA = -1, gB = 48, wB = 97, UB = 101, Ms = 102, xs = 117, Ss = 122, uB = 65, CB = 69, lB = 70, Gs = 85, Ts = 90, J = function(A) {
  return A >= gB && A <= 57;
}, Os = function(A) {
  return A >= 55296 && A <= 57343;
}, mA = function(A) {
  return J(A) || A >= uB && A <= lB || A >= wB && A <= Ms;
}, Vs = function(A) {
  return A >= wB && A <= Ss;
}, ks = function(A) {
  return A >= uB && A <= Ts;
}, Rs = function(A) {
  return Vs(A) || ks(A);
}, Ps = function(A) {
  return A >= ps;
}, he = function(A) {
  return A === Ge || A === os || A === is;
}, Te = function(A) {
  return Rs(A) || Ps(A) || A === gs;
}, dr = function(A) {
  return Te(A) || J(A) || A === _;
}, Js = function(A) {
  return A >= Ks && A <= ms || A === Ls || A >= bs && A <= Ds || A === vs;
}, gA = function(A, e) {
  return A !== jA ? !1 : e !== Ge;
}, de = function(A, e, r) {
  return A === _ ? Te(e) || gA(e, r) : Te(A) ? !0 : !!(A === jA && gA(A, e));
}, ut = function(A, e, r) {
  return A === hA || A === _ ? J(e) ? !0 : e === te && J(r) : J(A === te ? e : A);
}, Xs = function(A) {
  var e = 0, r = 1;
  (A[e] === hA || A[e] === _) && (A[e] === _ && (r = -1), e++);
  for (var t = []; J(A[e]); )
    t.push(A[e++]);
  var B = t.length ? parseInt(x.apply(void 0, t), 10) : 0;
  A[e] === te && e++;
  for (var n = []; J(A[e]); )
    n.push(A[e++]);
  var s = n.length, o = s ? parseInt(x.apply(void 0, n), 10) : 0;
  (A[e] === CB || A[e] === UB) && e++;
  var i = 1;
  (A[e] === hA || A[e] === _) && (A[e] === _ && (i = -1), e++);
  for (var Q = []; J(A[e]); )
    Q.push(A[e++]);
  var a = Q.length ? parseInt(x.apply(void 0, Q), 10) : 0;
  return r * (B + o * Math.pow(10, -s)) * Math.pow(10, i * a);
}, _s = {
  type: 2
  /* LEFT_PARENTHESIS_TOKEN */
}, Ns = {
  type: 3
  /* RIGHT_PARENTHESIS_TOKEN */
}, Ys = {
  type: 4
  /* COMMA_TOKEN */
}, Ws = {
  type: 13
  /* SUFFIX_MATCH_TOKEN */
}, Zs = {
  type: 8
  /* PREFIX_MATCH_TOKEN */
}, zs = {
  type: 21
  /* COLUMN_TOKEN */
}, qs = {
  type: 9
  /* DASH_MATCH_TOKEN */
}, js = {
  type: 10
  /* INCLUDE_MATCH_TOKEN */
}, $s = {
  type: 11
  /* LEFT_CURLY_BRACKET_TOKEN */
}, Ao = {
  type: 12
  /* RIGHT_CURLY_BRACKET_TOKEN */
}, eo = {
  type: 14
  /* SUBSTRING_MATCH_TOKEN */
}, fe = {
  type: 23
  /* BAD_URL_TOKEN */
}, to = {
  type: 1
  /* BAD_STRING_TOKEN */
}, ro = {
  type: 25
  /* CDO_TOKEN */
}, Bo = {
  type: 24
  /* CDC_TOKEN */
}, no = {
  type: 26
  /* COLON_TOKEN */
}, so = {
  type: 27
  /* SEMICOLON_TOKEN */
}, oo = {
  type: 28
  /* LEFT_SQUARE_BRACKET_TOKEN */
}, io = {
  type: 29
  /* RIGHT_SQUARE_BRACKET_TOKEN */
}, Qo = {
  type: 31
  /* WHITESPACE_TOKEN */
}, kt = {
  type: 32
  /* EOF_TOKEN */
}, FB = (
  /** @class */
  function() {
    function A() {
      this._value = [];
    }
    return A.prototype.write = function(e) {
      this._value = this._value.concat(Xe(e));
    }, A.prototype.read = function() {
      for (var e = [], r = this.consumeToken(); r !== kt; )
        e.push(r), r = this.consumeToken();
      return e;
    }, A.prototype.consumeToken = function() {
      var e = this.consumeCodePoint();
      switch (e) {
        case ue:
          return this.consumeStringToken(ue);
        case Qs:
          var r = this.peekCodePoint(0), t = this.peekCodePoint(1), B = this.peekCodePoint(2);
          if (dr(r) || gA(t, B)) {
            var n = de(r, t, B) ? ss : ns, s = this.consumeName();
            return { type: 5, value: s, flags: n };
          }
          break;
        case as:
          if (this.peekCodePoint(0) === RA)
            return this.consumeCodePoint(), Ws;
          break;
        case Ce:
          return this.consumeStringToken(Ce);
        case le:
          return _s;
        case PA:
          return Ns;
        case Ut:
          if (this.peekCodePoint(0) === RA)
            return this.consumeCodePoint(), eo;
          break;
        case hA:
          if (ut(e, this.peekCodePoint(0), this.peekCodePoint(1)))
            return this.reconsumeCodePoint(e), this.consumeNumericToken();
          break;
        case Es:
          return Ys;
        case _:
          var o = e, i = this.peekCodePoint(0), Q = this.peekCodePoint(1);
          if (ut(o, i, Q))
            return this.reconsumeCodePoint(e), this.consumeNumericToken();
          if (de(o, i, Q))
            return this.reconsumeCodePoint(e), this.consumeIdentLikeToken();
          if (i === _ && Q === us)
            return this.consumeCodePoint(), this.consumeCodePoint(), Bo;
          break;
        case te:
          if (ut(e, this.peekCodePoint(0), this.peekCodePoint(1)))
            return this.reconsumeCodePoint(e), this.consumeNumericToken();
          break;
        case lr:
          if (this.peekCodePoint(0) === Ut)
            for (this.consumeCodePoint(); ; ) {
              var a = this.consumeCodePoint();
              if (a === Ut && (a = this.consumeCodePoint(), a === lr))
                return this.consumeToken();
              if (a === rA)
                return this.consumeToken();
            }
          break;
        case Is:
          return no;
        case ys:
          return so;
        case Us:
          if (this.peekCodePoint(0) === ws && this.peekCodePoint(1) === _ && this.peekCodePoint(2) === _)
            return this.consumeCodePoint(), this.consumeCodePoint(), ro;
          break;
        case Cs:
          var c = this.peekCodePoint(0), g = this.peekCodePoint(1), U = this.peekCodePoint(2);
          if (de(c, g, U)) {
            var s = this.consumeName();
            return { type: 7, value: s };
          }
          break;
        case ls:
          return oo;
        case jA:
          if (gA(e, this.peekCodePoint(0)))
            return this.reconsumeCodePoint(e), this.consumeIdentLikeToken();
          break;
        case Fs:
          return io;
        case hs:
          if (this.peekCodePoint(0) === RA)
            return this.consumeCodePoint(), Zs;
          break;
        case ds:
          return $s;
        case fs:
          return Ao;
        case xs:
        case Gs:
          var w = this.peekCodePoint(0), C = this.peekCodePoint(1);
          return w === hA && (mA(C) || C === Fe) && (this.consumeCodePoint(), this.consumeUnicodeRangeToken()), this.reconsumeCodePoint(e), this.consumeIdentLikeToken();
        case Fr:
          if (this.peekCodePoint(0) === RA)
            return this.consumeCodePoint(), qs;
          if (this.peekCodePoint(0) === Fr)
            return this.consumeCodePoint(), zs;
          break;
        case Hs:
          if (this.peekCodePoint(0) === RA)
            return this.consumeCodePoint(), js;
          break;
        case rA:
          return kt;
      }
      return he(e) ? (this.consumeWhiteSpace(), Qo) : J(e) ? (this.reconsumeCodePoint(e), this.consumeNumericToken()) : Te(e) ? (this.reconsumeCodePoint(e), this.consumeIdentLikeToken()) : { type: 6, value: x(e) };
    }, A.prototype.consumeCodePoint = function() {
      var e = this._value.shift();
      return typeof e > "u" ? -1 : e;
    }, A.prototype.reconsumeCodePoint = function(e) {
      this._value.unshift(e);
    }, A.prototype.peekCodePoint = function(e) {
      return e >= this._value.length ? -1 : this._value[e];
    }, A.prototype.consumeUnicodeRangeToken = function() {
      for (var e = [], r = this.consumeCodePoint(); mA(r) && e.length < 6; )
        e.push(r), r = this.consumeCodePoint();
      for (var t = !1; r === Fe && e.length < 6; )
        e.push(r), r = this.consumeCodePoint(), t = !0;
      if (t) {
        var B = parseInt(x.apply(void 0, e.map(function(i) {
          return i === Fe ? gB : i;
        })), 16), n = parseInt(x.apply(void 0, e.map(function(i) {
          return i === Fe ? lB : i;
        })), 16);
        return { type: 30, start: B, end: n };
      }
      var s = parseInt(x.apply(void 0, e), 16);
      if (this.peekCodePoint(0) === _ && mA(this.peekCodePoint(1))) {
        this.consumeCodePoint(), r = this.consumeCodePoint();
        for (var o = []; mA(r) && o.length < 6; )
          o.push(r), r = this.consumeCodePoint();
        var n = parseInt(x.apply(void 0, o), 16);
        return { type: 30, start: s, end: n };
      } else
        return { type: 30, start: s, end: s };
    }, A.prototype.consumeIdentLikeToken = function() {
      var e = this.consumeName();
      return e.toLowerCase() === "url" && this.peekCodePoint(0) === le ? (this.consumeCodePoint(), this.consumeUrlToken()) : this.peekCodePoint(0) === le ? (this.consumeCodePoint(), { type: 19, value: e }) : { type: 20, value: e };
    }, A.prototype.consumeUrlToken = function() {
      var e = [];
      if (this.consumeWhiteSpace(), this.peekCodePoint(0) === rA)
        return { type: 22, value: "" };
      var r = this.peekCodePoint(0);
      if (r === Ce || r === ue) {
        var t = this.consumeStringToken(this.consumeCodePoint());
        return t.type === 0 && (this.consumeWhiteSpace(), this.peekCodePoint(0) === rA || this.peekCodePoint(0) === PA) ? (this.consumeCodePoint(), { type: 22, value: t.value }) : (this.consumeBadUrlRemnants(), fe);
      }
      for (; ; ) {
        var B = this.consumeCodePoint();
        if (B === rA || B === PA)
          return { type: 22, value: x.apply(void 0, e) };
        if (he(B))
          return this.consumeWhiteSpace(), this.peekCodePoint(0) === rA || this.peekCodePoint(0) === PA ? (this.consumeCodePoint(), { type: 22, value: x.apply(void 0, e) }) : (this.consumeBadUrlRemnants(), fe);
        if (B === ue || B === Ce || B === le || Js(B))
          return this.consumeBadUrlRemnants(), fe;
        if (B === jA)
          if (gA(B, this.peekCodePoint(0)))
            e.push(this.consumeEscapedCodePoint());
          else
            return this.consumeBadUrlRemnants(), fe;
        else
          e.push(B);
      }
    }, A.prototype.consumeWhiteSpace = function() {
      for (; he(this.peekCodePoint(0)); )
        this.consumeCodePoint();
    }, A.prototype.consumeBadUrlRemnants = function() {
      for (; ; ) {
        var e = this.consumeCodePoint();
        if (e === PA || e === rA)
          return;
        gA(e, this.peekCodePoint(0)) && this.consumeEscapedCodePoint();
      }
    }, A.prototype.consumeStringSlice = function(e) {
      for (var r = 5e4, t = ""; e > 0; ) {
        var B = Math.min(r, e);
        t += x.apply(void 0, this._value.splice(0, B)), e -= B;
      }
      return this._value.shift(), t;
    }, A.prototype.consumeStringToken = function(e) {
      var r = "", t = 0;
      do {
        var B = this._value[t];
        if (B === rA || B === void 0 || B === e)
          return r += this.consumeStringSlice(t), { type: 0, value: r };
        if (B === Ge)
          return this._value.splice(0, t), to;
        if (B === jA) {
          var n = this._value[t + 1];
          n !== rA && n !== void 0 && (n === Ge ? (r += this.consumeStringSlice(t), t = -1, this._value.shift()) : gA(B, n) && (r += this.consumeStringSlice(t), r += x(this.consumeEscapedCodePoint()), t = -1));
        }
        t++;
      } while (!0);
    }, A.prototype.consumeNumber = function() {
      var e = [], r = Be, t = this.peekCodePoint(0);
      for ((t === hA || t === _) && e.push(this.consumeCodePoint()); J(this.peekCodePoint(0)); )
        e.push(this.consumeCodePoint());
      t = this.peekCodePoint(0);
      var B = this.peekCodePoint(1);
      if (t === te && J(B))
        for (e.push(this.consumeCodePoint(), this.consumeCodePoint()), r = Cr; J(this.peekCodePoint(0)); )
          e.push(this.consumeCodePoint());
      t = this.peekCodePoint(0), B = this.peekCodePoint(1);
      var n = this.peekCodePoint(2);
      if ((t === CB || t === UB) && ((B === hA || B === _) && J(n) || J(B)))
        for (e.push(this.consumeCodePoint(), this.consumeCodePoint()), r = Cr; J(this.peekCodePoint(0)); )
          e.push(this.consumeCodePoint());
      return [Xs(e), r];
    }, A.prototype.consumeNumericToken = function() {
      var e = this.consumeNumber(), r = e[0], t = e[1], B = this.peekCodePoint(0), n = this.peekCodePoint(1), s = this.peekCodePoint(2);
      if (de(B, n, s)) {
        var o = this.consumeName();
        return { type: 15, number: r, flags: t, unit: o };
      }
      return B === cs ? (this.consumeCodePoint(), { type: 16, number: r, flags: t }) : { type: 17, number: r, flags: t };
    }, A.prototype.consumeEscapedCodePoint = function() {
      var e = this.consumeCodePoint();
      if (mA(e)) {
        for (var r = x(e); mA(this.peekCodePoint(0)) && r.length < 6; )
          r += x(this.consumeCodePoint());
        he(this.peekCodePoint(0)) && this.consumeCodePoint();
        var t = parseInt(r, 16);
        return t === 0 || Os(t) || t > 1114111 ? hr : t;
      }
      return e === rA ? hr : e;
    }, A.prototype.consumeName = function() {
      for (var e = ""; ; ) {
        var r = this.consumeCodePoint();
        if (dr(r))
          e += x(r);
        else if (gA(r, this.peekCodePoint(0)))
          e += x(this.consumeEscapedCodePoint());
        else
          return this.reconsumeCodePoint(r), e;
      }
    }, A;
  }()
), hB = (
  /** @class */
  function() {
    function A(e) {
      this._tokens = e;
    }
    return A.create = function(e) {
      var r = new FB();
      return r.write(e), new A(r.read());
    }, A.parseValue = function(e) {
      return A.create(e).parseComponentValue();
    }, A.parseValues = function(e) {
      return A.create(e).parseComponentValues();
    }, A.prototype.parseComponentValue = function() {
      for (var e = this.consumeToken(); e.type === 31; )
        e = this.consumeToken();
      if (e.type === 32)
        throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
      this.reconsumeToken(e);
      var r = this.consumeComponentValue();
      do
        e = this.consumeToken();
      while (e.type === 31);
      if (e.type === 32)
        return r;
      throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
    }, A.prototype.parseComponentValues = function() {
      for (var e = []; ; ) {
        var r = this.consumeComponentValue();
        if (r.type === 32)
          return e;
        e.push(r), e.push();
      }
    }, A.prototype.consumeComponentValue = function() {
      var e = this.consumeToken();
      switch (e.type) {
        case 11:
        case 28:
        case 2:
          return this.consumeSimpleBlock(e.type);
        case 19:
          return this.consumeFunction(e);
      }
      return e;
    }, A.prototype.consumeSimpleBlock = function(e) {
      for (var r = { type: e, values: [] }, t = this.consumeToken(); ; ) {
        if (t.type === 32 || ao(t, e))
          return r;
        this.reconsumeToken(t), r.values.push(this.consumeComponentValue()), t = this.consumeToken();
      }
    }, A.prototype.consumeFunction = function(e) {
      for (var r = {
        name: e.value,
        values: [],
        type: 18
        /* FUNCTION */
      }; ; ) {
        var t = this.consumeToken();
        if (t.type === 32 || t.type === 3)
          return r;
        this.reconsumeToken(t), r.values.push(this.consumeComponentValue());
      }
    }, A.prototype.consumeToken = function() {
      var e = this._tokens.shift();
      return typeof e > "u" ? kt : e;
    }, A.prototype.reconsumeToken = function(e) {
      this._tokens.unshift(e);
    }, A;
  }()
), ne = function(A) {
  return A.type === 15;
}, _e = function(A) {
  return A.type === 17;
}, v = function(A) {
  return A.type === 20;
}, Rt = function(A, e) {
  return v(A) && A.value === e;
}, Ne = function(A) {
  return A.type !== 31 && A.type !== 4;
}, BA = function(A) {
  var e = [], r = [];
  return A.forEach(function(t) {
    if (t.type === 4) {
      if (r.length === 0)
        throw new Error("Error parsing function args, zero tokens for arg");
      e.push(r), r = [];
      return;
    }
    t.type !== 31 && r.push(t);
  }), r.length && e.push(r), e;
}, ao = function(A, e) {
  return e === 11 && A.type === 12 || e === 28 && A.type === 29 ? !0 : e === 2 && A.type === 3;
}, lA = function(A) {
  return A.type === 17 || A.type === 15;
}, S = function(A) {
  return A.type === 16 || lA(A);
}, dB = function(A) {
  return A.length > 1 ? [A[0], A[1]] : [A[0]];
}, k = {
  type: 17,
  number: 0,
  flags: Be
}, qt = {
  type: 16,
  number: 50,
  flags: Be
}, UA = {
  type: 16,
  number: 100,
  flags: Be
}, ZA = function(A, e, r) {
  var t = A[0], B = A[1];
  return [b(t, e), b(typeof B < "u" ? B : t, r)];
}, b = function(A, e) {
  if (A.type === 16)
    return A.number / 100 * e;
  if (ne(A))
    switch (A.unit) {
      case "rem":
      case "em":
        return 16 * A.number;
      case "px":
      default:
        return A.number;
    }
  return A.number;
}, fB = "deg", HB = "grad", pB = "rad", EB = "turn", Ye = {
  name: "angle",
  parse: function(A, e) {
    if (e.type === 15)
      switch (e.unit) {
        case fB:
          return Math.PI * e.number / 180;
        case HB:
          return Math.PI / 200 * e.number;
        case pB:
          return e.number;
        case EB:
          return Math.PI * 2 * e.number;
      }
    throw new Error("Unsupported angle type");
  }
}, IB = function(A) {
  return A.type === 15 && (A.unit === fB || A.unit === HB || A.unit === pB || A.unit === EB);
}, yB = function(A) {
  var e = A.filter(v).map(function(r) {
    return r.value;
  }).join(" ");
  switch (e) {
    case "to bottom right":
    case "to right bottom":
    case "left top":
    case "top left":
      return [k, k];
    case "to top":
    case "bottom":
      return j(0);
    case "to bottom left":
    case "to left bottom":
    case "right top":
    case "top right":
      return [k, UA];
    case "to right":
    case "left":
      return j(90);
    case "to top left":
    case "to left top":
    case "right bottom":
    case "bottom right":
      return [UA, UA];
    case "to bottom":
    case "top":
      return j(180);
    case "to top right":
    case "to right top":
    case "left bottom":
    case "bottom left":
      return [UA, k];
    case "to left":
    case "right":
      return j(270);
  }
  return 0;
}, j = function(A) {
  return Math.PI * A / 180;
}, CA = {
  name: "color",
  parse: function(A, e) {
    if (e.type === 18) {
      var r = co[e.name];
      if (typeof r > "u")
        throw new Error('Attempting to parse an unsupported color function "' + e.name + '"');
      return r(A, e.values);
    }
    if (e.type === 5) {
      if (e.value.length === 3) {
        var t = e.value.substring(0, 1), B = e.value.substring(1, 2), n = e.value.substring(2, 3);
        return uA(parseInt(t + t, 16), parseInt(B + B, 16), parseInt(n + n, 16), 1);
      }
      if (e.value.length === 4) {
        var t = e.value.substring(0, 1), B = e.value.substring(1, 2), n = e.value.substring(2, 3), s = e.value.substring(3, 4);
        return uA(parseInt(t + t, 16), parseInt(B + B, 16), parseInt(n + n, 16), parseInt(s + s, 16) / 255);
      }
      if (e.value.length === 6) {
        var t = e.value.substring(0, 2), B = e.value.substring(2, 4), n = e.value.substring(4, 6);
        return uA(parseInt(t, 16), parseInt(B, 16), parseInt(n, 16), 1);
      }
      if (e.value.length === 8) {
        var t = e.value.substring(0, 2), B = e.value.substring(2, 4), n = e.value.substring(4, 6), s = e.value.substring(6, 8);
        return uA(parseInt(t, 16), parseInt(B, 16), parseInt(n, 16), parseInt(s, 16) / 255);
      }
    }
    if (e.type === 20) {
      var o = re[e.value.toUpperCase()];
      if (typeof o < "u")
        return o;
    }
    return re.TRANSPARENT;
  }
}, SA = function(A) {
  return (255 & A) === 0;
}, V = function(A) {
  var e = 255 & A, r = 255 & A >> 8, t = 255 & A >> 16, B = 255 & A >> 24;
  return e < 255 ? "rgba(" + B + "," + t + "," + r + "," + e / 255 + ")" : "rgb(" + B + "," + t + "," + r + ")";
}, uA = function(A, e, r, t) {
  return (A << 24 | e << 16 | r << 8 | Math.round(t * 255) << 0) >>> 0;
}, fr = function(A, e) {
  if (A.type === 17)
    return A.number;
  if (A.type === 16) {
    var r = e === 3 ? 1 : 255;
    return e === 3 ? A.number / 100 * r : Math.round(A.number / 100 * r);
  }
  return 0;
}, Hr = function(A, e) {
  var r = e.filter(Ne);
  if (r.length === 3) {
    var t = r.map(fr), B = t[0], n = t[1], s = t[2];
    return uA(B, n, s, 1);
  }
  if (r.length === 4) {
    var o = r.map(fr), B = o[0], n = o[1], s = o[2], i = o[3];
    return uA(B, n, s, i);
  }
  return 0;
};
function Ct(A, e, r) {
  return r < 0 && (r += 1), r >= 1 && (r -= 1), r < 1 / 6 ? (e - A) * r * 6 + A : r < 1 / 2 ? e : r < 2 / 3 ? (e - A) * 6 * (2 / 3 - r) + A : A;
}
var pr = function(A, e) {
  var r = e.filter(Ne), t = r[0], B = r[1], n = r[2], s = r[3], o = (t.type === 17 ? j(t.number) : Ye.parse(A, t)) / (Math.PI * 2), i = S(B) ? B.number / 100 : 0, Q = S(n) ? n.number / 100 : 0, a = typeof s < "u" && S(s) ? b(s, 1) : 1;
  if (i === 0)
    return uA(Q * 255, Q * 255, Q * 255, 1);
  var c = Q <= 0.5 ? Q * (i + 1) : Q + i - Q * i, g = Q * 2 - c, U = Ct(g, c, o + 1 / 3), w = Ct(g, c, o), C = Ct(g, c, o - 1 / 3);
  return uA(U * 255, w * 255, C * 255, a);
}, co = {
  hsl: pr,
  hsla: pr,
  rgb: Hr,
  rgba: Hr
}, Er = function(A, e) {
  return CA.parse(A, hB.create(e).parseComponentValue());
}, re = {
  ALICEBLUE: 4042850303,
  ANTIQUEWHITE: 4209760255,
  AQUA: 16777215,
  AQUAMARINE: 2147472639,
  AZURE: 4043309055,
  BEIGE: 4126530815,
  BISQUE: 4293182719,
  BLACK: 255,
  BLANCHEDALMOND: 4293643775,
  BLUE: 65535,
  BLUEVIOLET: 2318131967,
  BROWN: 2771004159,
  BURLYWOOD: 3736635391,
  CADETBLUE: 1604231423,
  CHARTREUSE: 2147418367,
  CHOCOLATE: 3530104575,
  CORAL: 4286533887,
  CORNFLOWERBLUE: 1687547391,
  CORNSILK: 4294499583,
  CRIMSON: 3692313855,
  CYAN: 16777215,
  DARKBLUE: 35839,
  DARKCYAN: 9145343,
  DARKGOLDENROD: 3095837695,
  DARKGRAY: 2846468607,
  DARKGREEN: 6553855,
  DARKGREY: 2846468607,
  DARKKHAKI: 3182914559,
  DARKMAGENTA: 2332068863,
  DARKOLIVEGREEN: 1433087999,
  DARKORANGE: 4287365375,
  DARKORCHID: 2570243327,
  DARKRED: 2332033279,
  DARKSALMON: 3918953215,
  DARKSEAGREEN: 2411499519,
  DARKSLATEBLUE: 1211993087,
  DARKSLATEGRAY: 793726975,
  DARKSLATEGREY: 793726975,
  DARKTURQUOISE: 13554175,
  DARKVIOLET: 2483082239,
  DEEPPINK: 4279538687,
  DEEPSKYBLUE: 12582911,
  DIMGRAY: 1768516095,
  DIMGREY: 1768516095,
  DODGERBLUE: 512819199,
  FIREBRICK: 2988581631,
  FLORALWHITE: 4294635775,
  FORESTGREEN: 579543807,
  FUCHSIA: 4278255615,
  GAINSBORO: 3705462015,
  GHOSTWHITE: 4177068031,
  GOLD: 4292280575,
  GOLDENROD: 3668254975,
  GRAY: 2155905279,
  GREEN: 8388863,
  GREENYELLOW: 2919182335,
  GREY: 2155905279,
  HONEYDEW: 4043305215,
  HOTPINK: 4285117695,
  INDIANRED: 3445382399,
  INDIGO: 1258324735,
  IVORY: 4294963455,
  KHAKI: 4041641215,
  LAVENDER: 3873897215,
  LAVENDERBLUSH: 4293981695,
  LAWNGREEN: 2096890111,
  LEMONCHIFFON: 4294626815,
  LIGHTBLUE: 2916673279,
  LIGHTCORAL: 4034953471,
  LIGHTCYAN: 3774873599,
  LIGHTGOLDENRODYELLOW: 4210742015,
  LIGHTGRAY: 3553874943,
  LIGHTGREEN: 2431553791,
  LIGHTGREY: 3553874943,
  LIGHTPINK: 4290167295,
  LIGHTSALMON: 4288707327,
  LIGHTSEAGREEN: 548580095,
  LIGHTSKYBLUE: 2278488831,
  LIGHTSLATEGRAY: 2005441023,
  LIGHTSLATEGREY: 2005441023,
  LIGHTSTEELBLUE: 2965692159,
  LIGHTYELLOW: 4294959359,
  LIME: 16711935,
  LIMEGREEN: 852308735,
  LINEN: 4210091775,
  MAGENTA: 4278255615,
  MAROON: 2147483903,
  MEDIUMAQUAMARINE: 1724754687,
  MEDIUMBLUE: 52735,
  MEDIUMORCHID: 3126187007,
  MEDIUMPURPLE: 2473647103,
  MEDIUMSEAGREEN: 1018393087,
  MEDIUMSLATEBLUE: 2070474495,
  MEDIUMSPRINGGREEN: 16423679,
  MEDIUMTURQUOISE: 1221709055,
  MEDIUMVIOLETRED: 3340076543,
  MIDNIGHTBLUE: 421097727,
  MINTCREAM: 4127193855,
  MISTYROSE: 4293190143,
  MOCCASIN: 4293178879,
  NAVAJOWHITE: 4292783615,
  NAVY: 33023,
  OLDLACE: 4260751103,
  OLIVE: 2155872511,
  OLIVEDRAB: 1804477439,
  ORANGE: 4289003775,
  ORANGERED: 4282712319,
  ORCHID: 3664828159,
  PALEGOLDENROD: 4008225535,
  PALEGREEN: 2566625535,
  PALETURQUOISE: 2951671551,
  PALEVIOLETRED: 3681588223,
  PAPAYAWHIP: 4293907967,
  PEACHPUFF: 4292524543,
  PERU: 3448061951,
  PINK: 4290825215,
  PLUM: 3718307327,
  POWDERBLUE: 2967529215,
  PURPLE: 2147516671,
  REBECCAPURPLE: 1714657791,
  RED: 4278190335,
  ROSYBROWN: 3163525119,
  ROYALBLUE: 1097458175,
  SADDLEBROWN: 2336560127,
  SALMON: 4202722047,
  SANDYBROWN: 4104413439,
  SEAGREEN: 780883967,
  SEASHELL: 4294307583,
  SIENNA: 2689740287,
  SILVER: 3233857791,
  SKYBLUE: 2278484991,
  SLATEBLUE: 1784335871,
  SLATEGRAY: 1887473919,
  SLATEGREY: 1887473919,
  SNOW: 4294638335,
  SPRINGGREEN: 16744447,
  STEELBLUE: 1182971135,
  TAN: 3535047935,
  TEAL: 8421631,
  THISTLE: 3636451583,
  TOMATO: 4284696575,
  TRANSPARENT: 0,
  TURQUOISE: 1088475391,
  VIOLET: 4001558271,
  WHEAT: 4125012991,
  WHITE: 4294967295,
  WHITESMOKE: 4126537215,
  YELLOW: 4294902015,
  YELLOWGREEN: 2597139199
}, go = {
  name: "background-clip",
  initialValue: "border-box",
  prefix: !1,
  type: 1,
  parse: function(A, e) {
    return e.map(function(r) {
      if (v(r))
        switch (r.value) {
          case "padding-box":
            return 1;
          case "content-box":
            return 2;
        }
      return 0;
    });
  }
}, wo = {
  name: "background-color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, We = function(A, e) {
  var r = CA.parse(A, e[0]), t = e[1];
  return t && S(t) ? { color: r, stop: t } : { color: r, stop: null };
}, Ir = function(A, e) {
  var r = A[0], t = A[A.length - 1];
  r.stop === null && (r.stop = k), t.stop === null && (t.stop = UA);
  for (var B = [], n = 0, s = 0; s < A.length; s++) {
    var o = A[s].stop;
    if (o !== null) {
      var i = b(o, e);
      i > n ? B.push(i) : B.push(n), n = i;
    } else
      B.push(null);
  }
  for (var Q = null, s = 0; s < B.length; s++) {
    var a = B[s];
    if (a === null)
      Q === null && (Q = s);
    else if (Q !== null) {
      for (var c = s - Q, g = B[Q - 1], U = (a - g) / (c + 1), w = 1; w <= c; w++)
        B[Q + w - 1] = U * w;
      Q = null;
    }
  }
  return A.map(function(C, I) {
    var h = C.color;
    return { color: h, stop: Math.max(Math.min(1, B[I] / e), 0) };
  });
}, Uo = function(A, e, r) {
  var t = e / 2, B = r / 2, n = b(A[0], e) - t, s = B - b(A[1], r);
  return (Math.atan2(s, n) + Math.PI * 2) % (Math.PI * 2);
}, uo = function(A, e, r) {
  var t = typeof A == "number" ? A : Uo(A, e, r), B = Math.abs(e * Math.sin(t)) + Math.abs(r * Math.cos(t)), n = e / 2, s = r / 2, o = B / 2, i = Math.sin(t - Math.PI / 2) * o, Q = Math.cos(t - Math.PI / 2) * o;
  return [B, n - Q, n + Q, s - i, s + i];
}, eA = function(A, e) {
  return Math.sqrt(A * A + e * e);
}, yr = function(A, e, r, t, B) {
  var n = [
    [0, 0],
    [0, e],
    [A, 0],
    [A, e]
  ];
  return n.reduce(function(s, o) {
    var i = o[0], Q = o[1], a = eA(r - i, t - Q);
    return (B ? a < s.optimumDistance : a > s.optimumDistance) ? {
      optimumCorner: o,
      optimumDistance: a
    } : s;
  }, {
    optimumDistance: B ? 1 / 0 : -1 / 0,
    optimumCorner: null
  }).optimumCorner;
}, Co = function(A, e, r, t, B) {
  var n = 0, s = 0;
  switch (A.size) {
    case 0:
      A.shape === 0 ? n = s = Math.min(Math.abs(e), Math.abs(e - t), Math.abs(r), Math.abs(r - B)) : A.shape === 1 && (n = Math.min(Math.abs(e), Math.abs(e - t)), s = Math.min(Math.abs(r), Math.abs(r - B)));
      break;
    case 2:
      if (A.shape === 0)
        n = s = Math.min(eA(e, r), eA(e, r - B), eA(e - t, r), eA(e - t, r - B));
      else if (A.shape === 1) {
        var o = Math.min(Math.abs(r), Math.abs(r - B)) / Math.min(Math.abs(e), Math.abs(e - t)), i = yr(t, B, e, r, !0), Q = i[0], a = i[1];
        n = eA(Q - e, (a - r) / o), s = o * n;
      }
      break;
    case 1:
      A.shape === 0 ? n = s = Math.max(Math.abs(e), Math.abs(e - t), Math.abs(r), Math.abs(r - B)) : A.shape === 1 && (n = Math.max(Math.abs(e), Math.abs(e - t)), s = Math.max(Math.abs(r), Math.abs(r - B)));
      break;
    case 3:
      if (A.shape === 0)
        n = s = Math.max(eA(e, r), eA(e, r - B), eA(e - t, r), eA(e - t, r - B));
      else if (A.shape === 1) {
        var o = Math.max(Math.abs(r), Math.abs(r - B)) / Math.max(Math.abs(e), Math.abs(e - t)), c = yr(t, B, e, r, !1), Q = c[0], a = c[1];
        n = eA(Q - e, (a - r) / o), s = o * n;
      }
      break;
  }
  return Array.isArray(A.size) && (n = b(A.size[0], t), s = A.size.length === 2 ? b(A.size[1], B) : n), [n, s];
}, lo = function(A, e) {
  var r = j(180), t = [];
  return BA(e).forEach(function(B, n) {
    if (n === 0) {
      var s = B[0];
      if (s.type === 20 && s.value === "to") {
        r = yB(B);
        return;
      } else if (IB(s)) {
        r = Ye.parse(A, s);
        return;
      }
    }
    var o = We(A, B);
    t.push(o);
  }), {
    angle: r,
    stops: t,
    type: 1
    /* LINEAR_GRADIENT */
  };
}, He = function(A, e) {
  var r = j(180), t = [];
  return BA(e).forEach(function(B, n) {
    if (n === 0) {
      var s = B[0];
      if (s.type === 20 && ["top", "left", "right", "bottom"].indexOf(s.value) !== -1) {
        r = yB(B);
        return;
      } else if (IB(s)) {
        r = (Ye.parse(A, s) + j(270)) % j(360);
        return;
      }
    }
    var o = We(A, B);
    t.push(o);
  }), {
    angle: r,
    stops: t,
    type: 1
    /* LINEAR_GRADIENT */
  };
}, Fo = function(A, e) {
  var r = j(180), t = [], B = 1, n = 0, s = 3, o = [];
  return BA(e).forEach(function(i, Q) {
    var a = i[0];
    if (Q === 0) {
      if (v(a) && a.value === "linear") {
        B = 1;
        return;
      } else if (v(a) && a.value === "radial") {
        B = 2;
        return;
      }
    }
    if (a.type === 18) {
      if (a.name === "from") {
        var c = CA.parse(A, a.values[0]);
        t.push({ stop: k, color: c });
      } else if (a.name === "to") {
        var c = CA.parse(A, a.values[0]);
        t.push({ stop: UA, color: c });
      } else if (a.name === "color-stop") {
        var g = a.values.filter(Ne);
        if (g.length === 2) {
          var c = CA.parse(A, g[1]), U = g[0];
          _e(U) && t.push({
            stop: { type: 16, number: U.number * 100, flags: U.flags },
            color: c
          });
        }
      }
    }
  }), B === 1 ? {
    angle: (r + j(180)) % j(360),
    stops: t,
    type: B
  } : { size: s, shape: n, stops: t, position: o, type: B };
}, KB = "closest-side", mB = "farthest-side", LB = "closest-corner", bB = "farthest-corner", DB = "circle", vB = "ellipse", MB = "cover", xB = "contain", ho = function(A, e) {
  var r = 0, t = 3, B = [], n = [];
  return BA(e).forEach(function(s, o) {
    var i = !0;
    if (o === 0) {
      var Q = !1;
      i = s.reduce(function(c, g) {
        if (Q)
          if (v(g))
            switch (g.value) {
              case "center":
                return n.push(qt), c;
              case "top":
              case "left":
                return n.push(k), c;
              case "right":
              case "bottom":
                return n.push(UA), c;
            }
          else (S(g) || lA(g)) && n.push(g);
        else if (v(g))
          switch (g.value) {
            case DB:
              return r = 0, !1;
            case vB:
              return r = 1, !1;
            case "at":
              return Q = !0, !1;
            case KB:
              return t = 0, !1;
            case MB:
            case mB:
              return t = 1, !1;
            case xB:
            case LB:
              return t = 2, !1;
            case bB:
              return t = 3, !1;
          }
        else if (lA(g) || S(g))
          return Array.isArray(t) || (t = []), t.push(g), !1;
        return c;
      }, i);
    }
    if (i) {
      var a = We(A, s);
      B.push(a);
    }
  }), {
    size: t,
    shape: r,
    stops: B,
    position: n,
    type: 2
    /* RADIAL_GRADIENT */
  };
}, pe = function(A, e) {
  var r = 0, t = 3, B = [], n = [];
  return BA(e).forEach(function(s, o) {
    var i = !0;
    if (o === 0 ? i = s.reduce(function(a, c) {
      if (v(c))
        switch (c.value) {
          case "center":
            return n.push(qt), !1;
          case "top":
          case "left":
            return n.push(k), !1;
          case "right":
          case "bottom":
            return n.push(UA), !1;
        }
      else if (S(c) || lA(c))
        return n.push(c), !1;
      return a;
    }, i) : o === 1 && (i = s.reduce(function(a, c) {
      if (v(c))
        switch (c.value) {
          case DB:
            return r = 0, !1;
          case vB:
            return r = 1, !1;
          case xB:
          case KB:
            return t = 0, !1;
          case mB:
            return t = 1, !1;
          case LB:
            return t = 2, !1;
          case MB:
          case bB:
            return t = 3, !1;
        }
      else if (lA(c) || S(c))
        return Array.isArray(t) || (t = []), t.push(c), !1;
      return a;
    }, i)), i) {
      var Q = We(A, s);
      B.push(Q);
    }
  }), {
    size: t,
    shape: r,
    stops: B,
    position: n,
    type: 2
    /* RADIAL_GRADIENT */
  };
}, fo = function(A) {
  return A.type === 1;
}, Ho = function(A) {
  return A.type === 2;
}, jt = {
  name: "image",
  parse: function(A, e) {
    if (e.type === 22) {
      var r = {
        url: e.value,
        type: 0
        /* URL */
      };
      return A.cache.addImage(e.value), r;
    }
    if (e.type === 18) {
      var t = SB[e.name];
      if (typeof t > "u")
        throw new Error('Attempting to parse an unsupported image function "' + e.name + '"');
      return t(A, e.values);
    }
    throw new Error("Unsupported image type " + e.type);
  }
};
function po(A) {
  return !(A.type === 20 && A.value === "none") && (A.type !== 18 || !!SB[A.name]);
}
var SB = {
  "linear-gradient": lo,
  "-moz-linear-gradient": He,
  "-ms-linear-gradient": He,
  "-o-linear-gradient": He,
  "-webkit-linear-gradient": He,
  "radial-gradient": ho,
  "-moz-radial-gradient": pe,
  "-ms-radial-gradient": pe,
  "-o-radial-gradient": pe,
  "-webkit-radial-gradient": pe,
  "-webkit-gradient": Fo
}, Eo = {
  name: "background-image",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(A, e) {
    if (e.length === 0)
      return [];
    var r = e[0];
    return r.type === 20 && r.value === "none" ? [] : e.filter(function(t) {
      return Ne(t) && po(t);
    }).map(function(t) {
      return jt.parse(A, t);
    });
  }
}, Io = {
  name: "background-origin",
  initialValue: "border-box",
  prefix: !1,
  type: 1,
  parse: function(A, e) {
    return e.map(function(r) {
      if (v(r))
        switch (r.value) {
          case "padding-box":
            return 1;
          case "content-box":
            return 2;
        }
      return 0;
    });
  }
}, yo = {
  name: "background-position",
  initialValue: "0% 0%",
  type: 1,
  prefix: !1,
  parse: function(A, e) {
    return BA(e).map(function(r) {
      return r.filter(S);
    }).map(dB);
  }
}, Ko = {
  name: "background-repeat",
  initialValue: "repeat",
  prefix: !1,
  type: 1,
  parse: function(A, e) {
    return BA(e).map(function(r) {
      return r.filter(v).map(function(t) {
        return t.value;
      }).join(" ");
    }).map(mo);
  }
}, mo = function(A) {
  switch (A) {
    case "no-repeat":
      return 1;
    case "repeat-x":
    case "repeat no-repeat":
      return 2;
    case "repeat-y":
    case "no-repeat repeat":
      return 3;
    case "repeat":
    default:
      return 0;
  }
}, GA;
(function(A) {
  A.AUTO = "auto", A.CONTAIN = "contain", A.COVER = "cover";
})(GA || (GA = {}));
var Lo = {
  name: "background-size",
  initialValue: "0",
  prefix: !1,
  type: 1,
  parse: function(A, e) {
    return BA(e).map(function(r) {
      return r.filter(bo);
    });
  }
}, bo = function(A) {
  return v(A) || S(A);
}, Ze = function(A) {
  return {
    name: "border-" + A + "-color",
    initialValue: "transparent",
    prefix: !1,
    type: 3,
    format: "color"
  };
}, Do = Ze("top"), vo = Ze("right"), Mo = Ze("bottom"), xo = Ze("left"), ze = function(A) {
  return {
    name: "border-radius-" + A,
    initialValue: "0 0",
    prefix: !1,
    type: 1,
    parse: function(e, r) {
      return dB(r.filter(S));
    }
  };
}, So = ze("top-left"), Go = ze("top-right"), To = ze("bottom-right"), Oo = ze("bottom-left"), qe = function(A) {
  return {
    name: "border-" + A + "-style",
    initialValue: "solid",
    prefix: !1,
    type: 2,
    parse: function(e, r) {
      switch (r) {
        case "none":
          return 0;
        case "dashed":
          return 2;
        case "dotted":
          return 3;
        case "double":
          return 4;
      }
      return 1;
    }
  };
}, Vo = qe("top"), ko = qe("right"), Ro = qe("bottom"), Po = qe("left"), je = function(A) {
  return {
    name: "border-" + A + "-width",
    initialValue: "0",
    type: 0,
    prefix: !1,
    parse: function(e, r) {
      return ne(r) ? r.number : 0;
    }
  };
}, Jo = je("top"), Xo = je("right"), _o = je("bottom"), No = je("left"), Yo = {
  name: "color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, Wo = {
  name: "direction",
  initialValue: "ltr",
  prefix: !1,
  type: 2,
  parse: function(A, e) {
    switch (e) {
      case "rtl":
        return 1;
      case "ltr":
      default:
        return 0;
    }
  }
}, Zo = {
  name: "display",
  initialValue: "inline-block",
  prefix: !1,
  type: 1,
  parse: function(A, e) {
    return e.filter(v).reduce(
      function(r, t) {
        return r | zo(t.value);
      },
      0
      /* NONE */
    );
  }
}, zo = function(A) {
  switch (A) {
    case "block":
    case "-webkit-box":
      return 2;
    case "inline":
      return 4;
    case "run-in":
      return 8;
    case "flow":
      return 16;
    case "flow-root":
      return 32;
    case "table":
      return 64;
    case "flex":
    case "-webkit-flex":
      return 128;
    case "grid":
    case "-ms-grid":
      return 256;
    case "ruby":
      return 512;
    case "subgrid":
      return 1024;
    case "list-item":
      return 2048;
    case "table-row-group":
      return 4096;
    case "table-header-group":
      return 8192;
    case "table-footer-group":
      return 16384;
    case "table-row":
      return 32768;
    case "table-cell":
      return 65536;
    case "table-column-group":
      return 131072;
    case "table-column":
      return 262144;
    case "table-caption":
      return 524288;
    case "ruby-base":
      return 1048576;
    case "ruby-text":
      return 2097152;
    case "ruby-base-container":
      return 4194304;
    case "ruby-text-container":
      return 8388608;
    case "contents":
      return 16777216;
    case "inline-block":
      return 33554432;
    case "inline-list-item":
      return 67108864;
    case "inline-table":
      return 134217728;
    case "inline-flex":
      return 268435456;
    case "inline-grid":
      return 536870912;
  }
  return 0;
}, qo = {
  name: "float",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(A, e) {
    switch (e) {
      case "left":
        return 1;
      case "right":
        return 2;
      case "inline-start":
        return 3;
      case "inline-end":
        return 4;
    }
    return 0;
  }
}, jo = {
  name: "letter-spacing",
  initialValue: "0",
  prefix: !1,
  type: 0,
  parse: function(A, e) {
    return e.type === 20 && e.value === "normal" ? 0 : e.type === 17 || e.type === 15 ? e.number : 0;
  }
}, Oe;
(function(A) {
  A.NORMAL = "normal", A.STRICT = "strict";
})(Oe || (Oe = {}));
var $o = {
  name: "line-break",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(A, e) {
    switch (e) {
      case "strict":
        return Oe.STRICT;
      case "normal":
      default:
        return Oe.NORMAL;
    }
  }
}, Ai = {
  name: "line-height",
  initialValue: "normal",
  prefix: !1,
  type: 4
  /* TOKEN_VALUE */
}, Kr = function(A, e) {
  return v(A) && A.value === "normal" ? 1.2 * e : A.type === 17 ? e * A.number : S(A) ? b(A, e) : e;
}, ei = {
  name: "list-style-image",
  initialValue: "none",
  type: 0,
  prefix: !1,
  parse: function(A, e) {
    return e.type === 20 && e.value === "none" ? null : jt.parse(A, e);
  }
}, ti = {
  name: "list-style-position",
  initialValue: "outside",
  prefix: !1,
  type: 2,
  parse: function(A, e) {
    switch (e) {
      case "inside":
        return 0;
      case "outside":
      default:
        return 1;
    }
  }
}, ri = {
  name: "list-style-type",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(A, e) {
    switch (e) {
      case "disc":
        return 0;
      case "circle":
        return 1;
      case "square":
        return 2;
      case "decimal":
        return 3;
      case "cjk-decimal":
        return 4;
      case "decimal-leading-zero":
        return 5;
      case "lower-roman":
        return 6;
      case "upper-roman":
        return 7;
      case "lower-greek":
        return 8;
      case "lower-alpha":
        return 9;
      case "upper-alpha":
        return 10;
      case "arabic-indic":
        return 11;
      case "armenian":
        return 12;
      case "bengali":
        return 13;
      case "cambodian":
        return 14;
      case "cjk-earthly-branch":
        return 15;
      case "cjk-heavenly-stem":
        return 16;
      case "cjk-ideographic":
        return 17;
      case "devanagari":
        return 18;
      case "ethiopic-numeric":
        return 19;
      case "georgian":
        return 20;
      case "gujarati":
        return 21;
      case "gurmukhi":
        return 22;
      case "hebrew":
        return 22;
      case "hiragana":
        return 23;
      case "hiragana-iroha":
        return 24;
      case "japanese-formal":
        return 25;
      case "japanese-informal":
        return 26;
      case "kannada":
        return 27;
      case "katakana":
        return 28;
      case "katakana-iroha":
        return 29;
      case "khmer":
        return 30;
      case "korean-hangul-formal":
        return 31;
      case "korean-hanja-formal":
        return 32;
      case "korean-hanja-informal":
        return 33;
      case "lao":
        return 34;
      case "lower-armenian":
        return 35;
      case "malayalam":
        return 36;
      case "mongolian":
        return 37;
      case "myanmar":
        return 38;
      case "oriya":
        return 39;
      case "persian":
        return 40;
      case "simp-chinese-formal":
        return 41;
      case "simp-chinese-informal":
        return 42;
      case "tamil":
        return 43;
      case "telugu":
        return 44;
      case "thai":
        return 45;
      case "tibetan":
        return 46;
      case "trad-chinese-formal":
        return 47;
      case "trad-chinese-informal":
        return 48;
      case "upper-armenian":
        return 49;
      case "disclosure-open":
        return 50;
      case "disclosure-closed":
        return 51;
      case "none":
      default:
        return -1;
    }
  }
}, $e = function(A) {
  return {
    name: "margin-" + A,
    initialValue: "0",
    prefix: !1,
    type: 4
    /* TOKEN_VALUE */
  };
}, Bi = $e("top"), ni = $e("right"), si = $e("bottom"), oi = $e("left"), ii = {
  name: "overflow",
  initialValue: "visible",
  prefix: !1,
  type: 1,
  parse: function(A, e) {
    return e.filter(v).map(function(r) {
      switch (r.value) {
        case "hidden":
          return 1;
        case "scroll":
          return 2;
        case "clip":
          return 3;
        case "auto":
          return 4;
        case "visible":
        default:
          return 0;
      }
    });
  }
}, Qi = {
  name: "overflow-wrap",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(A, e) {
    switch (e) {
      case "break-word":
        return "break-word";
      case "normal":
      default:
        return "normal";
    }
  }
}, At = function(A) {
  return {
    name: "padding-" + A,
    initialValue: "0",
    prefix: !1,
    type: 3,
    format: "length-percentage"
  };
}, ai = At("top"), ci = At("right"), gi = At("bottom"), wi = At("left"), Ui = {
  name: "text-align",
  initialValue: "left",
  prefix: !1,
  type: 2,
  parse: function(A, e) {
    switch (e) {
      case "right":
        return 2;
      case "center":
      case "justify":
        return 1;
      case "left":
      default:
        return 0;
    }
  }
}, ui = {
  name: "position",
  initialValue: "static",
  prefix: !1,
  type: 2,
  parse: function(A, e) {
    switch (e) {
      case "relative":
        return 1;
      case "absolute":
        return 2;
      case "fixed":
        return 3;
      case "sticky":
        return 4;
    }
    return 0;
  }
}, Ci = {
  name: "text-shadow",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(A, e) {
    return e.length === 1 && Rt(e[0], "none") ? [] : BA(e).map(function(r) {
      for (var t = {
        color: re.TRANSPARENT,
        offsetX: k,
        offsetY: k,
        blur: k
      }, B = 0, n = 0; n < r.length; n++) {
        var s = r[n];
        lA(s) ? (B === 0 ? t.offsetX = s : B === 1 ? t.offsetY = s : t.blur = s, B++) : t.color = CA.parse(A, s);
      }
      return t;
    });
  }
}, li = {
  name: "text-transform",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(A, e) {
    switch (e) {
      case "uppercase":
        return 2;
      case "lowercase":
        return 1;
      case "capitalize":
        return 3;
    }
    return 0;
  }
}, Fi = {
  name: "transform",
  initialValue: "none",
  prefix: !0,
  type: 0,
  parse: function(A, e) {
    if (e.type === 20 && e.value === "none")
      return null;
    if (e.type === 18) {
      var r = fi[e.name];
      if (typeof r > "u")
        throw new Error('Attempting to parse an unsupported transform function "' + e.name + '"');
      return r(e.values);
    }
    return null;
  }
}, hi = function(A) {
  var e = A.filter(function(r) {
    return r.type === 17;
  }).map(function(r) {
    return r.number;
  });
  return e.length === 6 ? e : null;
}, di = function(A) {
  var e = A.filter(function(i) {
    return i.type === 17;
  }).map(function(i) {
    return i.number;
  }), r = e[0], t = e[1];
  e[2], e[3];
  var B = e[4], n = e[5];
  e[6], e[7], e[8], e[9], e[10], e[11];
  var s = e[12], o = e[13];
  return e[14], e[15], e.length === 16 ? [r, t, B, n, s, o] : null;
}, fi = {
  matrix: hi,
  matrix3d: di
}, mr = {
  type: 16,
  number: 50,
  flags: Be
}, Hi = [mr, mr], pi = {
  name: "transform-origin",
  initialValue: "50% 50%",
  prefix: !0,
  type: 1,
  parse: function(A, e) {
    var r = e.filter(S);
    return r.length !== 2 ? Hi : [r[0], r[1]];
  }
}, Ei = {
  name: "visible",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(A, e) {
    switch (e) {
      case "hidden":
        return 1;
      case "collapse":
        return 2;
      case "visible":
      default:
        return 0;
    }
  }
}, $A;
(function(A) {
  A.NORMAL = "normal", A.BREAK_ALL = "break-all", A.KEEP_ALL = "keep-all";
})($A || ($A = {}));
var Ii = {
  name: "word-break",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(A, e) {
    switch (e) {
      case "break-all":
        return $A.BREAK_ALL;
      case "keep-all":
        return $A.KEEP_ALL;
      case "normal":
      default:
        return $A.NORMAL;
    }
  }
}, yi = {
  name: "z-index",
  initialValue: "auto",
  prefix: !1,
  type: 0,
  parse: function(A, e) {
    if (e.type === 20)
      return { auto: !0, order: 0 };
    if (_e(e))
      return { auto: !1, order: e.number };
    throw new Error("Invalid z-index number parsed");
  }
}, GB = {
  name: "time",
  parse: function(A, e) {
    if (e.type === 15)
      switch (e.unit.toLowerCase()) {
        case "s":
          return 1e3 * e.number;
        case "ms":
          return e.number;
      }
    throw new Error("Unsupported time type");
  }
}, Ki = {
  name: "opacity",
  initialValue: "1",
  type: 0,
  prefix: !1,
  parse: function(A, e) {
    return _e(e) ? e.number : 1;
  }
}, mi = {
  name: "text-decoration-color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, Li = {
  name: "text-decoration-line",
  initialValue: "none",
  prefix: !1,
  type: 1,
  parse: function(A, e) {
    return e.filter(v).map(function(r) {
      switch (r.value) {
        case "underline":
          return 1;
        case "overline":
          return 2;
        case "line-through":
          return 3;
        case "none":
          return 4;
      }
      return 0;
    }).filter(function(r) {
      return r !== 0;
    });
  }
}, bi = {
  name: "font-family",
  initialValue: "",
  prefix: !1,
  type: 1,
  parse: function(A, e) {
    var r = [], t = [];
    return e.forEach(function(B) {
      switch (B.type) {
        case 20:
        case 0:
          r.push(B.value);
          break;
        case 17:
          r.push(B.number.toString());
          break;
        case 4:
          t.push(r.join(" ")), r.length = 0;
          break;
      }
    }), r.length && t.push(r.join(" ")), t.map(function(B) {
      return B.indexOf(" ") === -1 ? B : "'" + B + "'";
    });
  }
}, Di = {
  name: "font-size",
  initialValue: "0",
  prefix: !1,
  type: 3,
  format: "length"
}, vi = {
  name: "font-weight",
  initialValue: "normal",
  type: 0,
  prefix: !1,
  parse: function(A, e) {
    if (_e(e))
      return e.number;
    if (v(e))
      switch (e.value) {
        case "bold":
          return 700;
        case "normal":
        default:
          return 400;
      }
    return 400;
  }
}, Mi = {
  name: "font-variant",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(A, e) {
    return e.filter(v).map(function(r) {
      return r.value;
    });
  }
}, xi = {
  name: "font-style",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(A, e) {
    switch (e) {
      case "oblique":
        return "oblique";
      case "italic":
        return "italic";
      case "normal":
      default:
        return "normal";
    }
  }
}, T = function(A, e) {
  return (A & e) !== 0;
}, Si = {
  name: "duration",
  initialValue: "0s",
  prefix: !1,
  type: 1,
  parse: function(A, e) {
    return e.filter(ne).map(function(r) {
      return GB.parse(A, r);
    });
  }
}, Gi = {
  name: "box-shadow",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(A, e) {
    return e.length === 1 && Rt(e[0], "none") ? [] : BA(e).map(function(r) {
      for (var t = {
        color: 255,
        offsetX: k,
        offsetY: k,
        blur: k,
        spread: k,
        inset: !1
      }, B = 0, n = 0; n < r.length; n++) {
        var s = r[n];
        Rt(s, "inset") ? t.inset = !0 : lA(s) ? (B === 0 ? t.offsetX = s : B === 1 ? t.offsetY = s : B === 2 ? t.blur = s : t.spread = s, B++) : t.color = CA.parse(A, s);
      }
      return t;
    });
  }
}, Ti = {
  name: "paint-order",
  initialValue: "normal",
  prefix: !1,
  type: 1,
  parse: function(A, e) {
    var r = [
      0,
      1,
      2
      /* MARKERS */
    ], t = [];
    return e.filter(v).forEach(function(B) {
      switch (B.value) {
        case "stroke":
          t.push(
            1
            /* STROKE */
          );
          break;
        case "fill":
          t.push(
            0
            /* FILL */
          );
          break;
        case "markers":
          t.push(
            2
            /* MARKERS */
          );
          break;
      }
    }), r.forEach(function(B) {
      t.indexOf(B) === -1 && t.push(B);
    }), t;
  }
}, Oi = {
  name: "-webkit-text-stroke-color",
  initialValue: "currentcolor",
  prefix: !1,
  type: 3,
  format: "color"
}, Vi = {
  name: "-webkit-text-stroke-width",
  initialValue: "0",
  type: 0,
  prefix: !1,
  parse: function(A, e) {
    return ne(e) ? e.number : 0;
  }
}, ki = (
  /** @class */
  function() {
    function A(e, r) {
      var t, B;
      this.animationDuration = F(e, Si, r.animationDuration), this.backgroundClip = F(e, go, r.backgroundClip), this.backgroundColor = F(e, wo, r.backgroundColor), this.backgroundImage = F(e, Eo, r.backgroundImage), this.backgroundOrigin = F(e, Io, r.backgroundOrigin), this.backgroundPosition = F(e, yo, r.backgroundPosition), this.backgroundRepeat = F(e, Ko, r.backgroundRepeat), this.backgroundSize = F(e, Lo, r.backgroundSize), this.borderTopColor = F(e, Do, r.borderTopColor), this.borderRightColor = F(e, vo, r.borderRightColor), this.borderBottomColor = F(e, Mo, r.borderBottomColor), this.borderLeftColor = F(e, xo, r.borderLeftColor), this.borderTopLeftRadius = F(e, So, r.borderTopLeftRadius), this.borderTopRightRadius = F(e, Go, r.borderTopRightRadius), this.borderBottomRightRadius = F(e, To, r.borderBottomRightRadius), this.borderBottomLeftRadius = F(e, Oo, r.borderBottomLeftRadius), this.borderTopStyle = F(e, Vo, r.borderTopStyle), this.borderRightStyle = F(e, ko, r.borderRightStyle), this.borderBottomStyle = F(e, Ro, r.borderBottomStyle), this.borderLeftStyle = F(e, Po, r.borderLeftStyle), this.borderTopWidth = F(e, Jo, r.borderTopWidth), this.borderRightWidth = F(e, Xo, r.borderRightWidth), this.borderBottomWidth = F(e, _o, r.borderBottomWidth), this.borderLeftWidth = F(e, No, r.borderLeftWidth), this.boxShadow = F(e, Gi, r.boxShadow), this.color = F(e, Yo, r.color), this.direction = F(e, Wo, r.direction), this.display = F(e, Zo, r.display), this.float = F(e, qo, r.cssFloat), this.fontFamily = F(e, bi, r.fontFamily), this.fontSize = F(e, Di, r.fontSize), this.fontStyle = F(e, xi, r.fontStyle), this.fontVariant = F(e, Mi, r.fontVariant), this.fontWeight = F(e, vi, r.fontWeight), this.letterSpacing = F(e, jo, r.letterSpacing), this.lineBreak = F(e, $o, r.lineBreak), this.lineHeight = F(e, Ai, r.lineHeight), this.listStyleImage = F(e, ei, r.listStyleImage), this.listStylePosition = F(e, ti, r.listStylePosition), this.listStyleType = F(e, ri, r.listStyleType), this.marginTop = F(e, Bi, r.marginTop), this.marginRight = F(e, ni, r.marginRight), this.marginBottom = F(e, si, r.marginBottom), this.marginLeft = F(e, oi, r.marginLeft), this.opacity = F(e, Ki, r.opacity);
      var n = F(e, ii, r.overflow);
      this.overflowX = n[0], this.overflowY = n[n.length > 1 ? 1 : 0], this.overflowWrap = F(e, Qi, r.overflowWrap), this.paddingTop = F(e, ai, r.paddingTop), this.paddingRight = F(e, ci, r.paddingRight), this.paddingBottom = F(e, gi, r.paddingBottom), this.paddingLeft = F(e, wi, r.paddingLeft), this.paintOrder = F(e, Ti, r.paintOrder), this.position = F(e, ui, r.position), this.textAlign = F(e, Ui, r.textAlign), this.textDecorationColor = F(e, mi, (t = r.textDecorationColor) !== null && t !== void 0 ? t : r.color), this.textDecorationLine = F(e, Li, (B = r.textDecorationLine) !== null && B !== void 0 ? B : r.textDecoration), this.textShadow = F(e, Ci, r.textShadow), this.textTransform = F(e, li, r.textTransform), this.transform = F(e, Fi, r.transform), this.transformOrigin = F(e, pi, r.transformOrigin), this.visibility = F(e, Ei, r.visibility), this.webkitTextStrokeColor = F(e, Oi, r.webkitTextStrokeColor), this.webkitTextStrokeWidth = F(e, Vi, r.webkitTextStrokeWidth), this.wordBreak = F(e, Ii, r.wordBreak), this.zIndex = F(e, yi, r.zIndex);
    }
    return A.prototype.isVisible = function() {
      return this.display > 0 && this.opacity > 0 && this.visibility === 0;
    }, A.prototype.isTransparent = function() {
      return SA(this.backgroundColor);
    }, A.prototype.isTransformed = function() {
      return this.transform !== null;
    }, A.prototype.isPositioned = function() {
      return this.position !== 0;
    }, A.prototype.isPositionedWithZIndex = function() {
      return this.isPositioned() && !this.zIndex.auto;
    }, A.prototype.isFloating = function() {
      return this.float !== 0;
    }, A.prototype.isInlineLevel = function() {
      return T(
        this.display,
        4
        /* INLINE */
      ) || T(
        this.display,
        33554432
        /* INLINE_BLOCK */
      ) || T(
        this.display,
        268435456
        /* INLINE_FLEX */
      ) || T(
        this.display,
        536870912
        /* INLINE_GRID */
      ) || T(
        this.display,
        67108864
        /* INLINE_LIST_ITEM */
      ) || T(
        this.display,
        134217728
        /* INLINE_TABLE */
      );
    }, A;
  }()
), F = function(A, e, r) {
  var t = new FB(), B = r !== null && typeof r < "u" ? r.toString() : e.initialValue;
  t.write(B);
  var n = new hB(t.read());
  switch (e.type) {
    case 2:
      var s = n.parseComponentValue();
      return e.parse(A, v(s) ? s.value : e.initialValue);
    case 0:
      return e.parse(A, n.parseComponentValue());
    case 1:
      return e.parse(A, n.parseComponentValues());
    case 4:
      return n.parseComponentValue();
    case 3:
      switch (e.format) {
        case "angle":
          return Ye.parse(A, n.parseComponentValue());
        case "color":
          return CA.parse(A, n.parseComponentValue());
        case "image":
          return jt.parse(A, n.parseComponentValue());
        case "length":
          var o = n.parseComponentValue();
          return lA(o) ? o : k;
        case "length-percentage":
          var i = n.parseComponentValue();
          return S(i) ? i : k;
        case "time":
          return GB.parse(A, n.parseComponentValue());
      }
      break;
  }
}, Ri = "data-html2canvas-debug", Pi = function(A) {
  var e = A.getAttribute(Ri);
  switch (e) {
    case "all":
      return 1;
    case "clone":
      return 2;
    case "parse":
      return 3;
    case "render":
      return 4;
    default:
      return 0;
  }
}, Lr = function(A, e) {
  var r = Pi(A);
  return r === 1 || e === r;
}, nA = (
  /** @class */
  /* @__PURE__ */ function() {
    function A(e, r) {
      if (this.context = e, this.textNodes = [], this.elements = [], this.flags = 0, Lr(
        r,
        3
        /* PARSE */
      ))
        debugger;
      this.styles = new ki(e, window.getComputedStyle(r, null)), PQ(r) && (this.styles.animationDuration.some(function(t) {
        return t > 0;
      }) && (r.style.animationDuration = "0s"), this.styles.transform !== null && (r.style.transform = "none")), this.bounds = Zt(this.context, r), Lr(
        r,
        4
        /* RENDER */
      ) && (this.flags |= 16);
    }
    return A;
  }()
), Ji = "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", br = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", zA = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Ee = 0; Ee < br.length; Ee++)
  zA[br.charCodeAt(Ee)] = Ee;
var Xi = function(A) {
  var e = A.length * 0.75, r = A.length, t, B = 0, n, s, o, i;
  A[A.length - 1] === "=" && (e--, A[A.length - 2] === "=" && e--);
  var Q = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && typeof Uint8Array.prototype.slice < "u" ? new ArrayBuffer(e) : new Array(e), a = Array.isArray(Q) ? Q : new Uint8Array(Q);
  for (t = 0; t < r; t += 4)
    n = zA[A.charCodeAt(t)], s = zA[A.charCodeAt(t + 1)], o = zA[A.charCodeAt(t + 2)], i = zA[A.charCodeAt(t + 3)], a[B++] = n << 2 | s >> 4, a[B++] = (s & 15) << 4 | o >> 2, a[B++] = (o & 3) << 6 | i & 63;
  return Q;
}, _i = function(A) {
  for (var e = A.length, r = [], t = 0; t < e; t += 2)
    r.push(A[t + 1] << 8 | A[t]);
  return r;
}, Ni = function(A) {
  for (var e = A.length, r = [], t = 0; t < e; t += 4)
    r.push(A[t + 3] << 24 | A[t + 2] << 16 | A[t + 1] << 8 | A[t]);
  return r;
}, HA = 5, $t = 11, lt = 2, Yi = $t - HA, TB = 65536 >> HA, Wi = 1 << HA, Ft = Wi - 1, Zi = 1024 >> HA, zi = TB + Zi, qi = zi, ji = 32, $i = qi + ji, AQ = 65536 >> $t, eQ = 1 << Yi, tQ = eQ - 1, Dr = function(A, e, r) {
  return A.slice ? A.slice(e, r) : new Uint16Array(Array.prototype.slice.call(A, e, r));
}, rQ = function(A, e, r) {
  return A.slice ? A.slice(e, r) : new Uint32Array(Array.prototype.slice.call(A, e, r));
}, BQ = function(A, e) {
  var r = Xi(A), t = Array.isArray(r) ? Ni(r) : new Uint32Array(r), B = Array.isArray(r) ? _i(r) : new Uint16Array(r), n = 24, s = Dr(B, n / 2, t[4] / 2), o = t[5] === 2 ? Dr(B, (n + t[4]) / 2) : rQ(t, Math.ceil((n + t[4]) / 4));
  return new nQ(t[0], t[1], t[2], t[3], s, o);
}, nQ = (
  /** @class */
  function() {
    function A(e, r, t, B, n, s) {
      this.initialValue = e, this.errorValue = r, this.highStart = t, this.highValueIndex = B, this.index = n, this.data = s;
    }
    return A.prototype.get = function(e) {
      var r;
      if (e >= 0) {
        if (e < 55296 || e > 56319 && e <= 65535)
          return r = this.index[e >> HA], r = (r << lt) + (e & Ft), this.data[r];
        if (e <= 65535)
          return r = this.index[TB + (e - 55296 >> HA)], r = (r << lt) + (e & Ft), this.data[r];
        if (e < this.highStart)
          return r = $i - AQ + (e >> $t), r = this.index[r], r += e >> HA & tQ, r = this.index[r], r = (r << lt) + (e & Ft), this.data[r];
        if (e <= 1114111)
          return this.data[this.highValueIndex];
      }
      return this.errorValue;
    }, A;
  }()
), vr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", sQ = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Ie = 0; Ie < vr.length; Ie++)
  sQ[vr.charCodeAt(Ie)] = Ie;
var oQ = 1, ht = 2, dt = 3, Mr = 4, xr = 5, iQ = 7, Sr = 8, ft = 9, Ht = 10, Gr = 11, Tr = 12, Or = 13, Vr = 14, pt = 15, QQ = function(A) {
  for (var e = [], r = 0, t = A.length; r < t; ) {
    var B = A.charCodeAt(r++);
    if (B >= 55296 && B <= 56319 && r < t) {
      var n = A.charCodeAt(r++);
      (n & 64512) === 56320 ? e.push(((B & 1023) << 10) + (n & 1023) + 65536) : (e.push(B), r--);
    } else
      e.push(B);
  }
  return e;
}, aQ = function() {
  for (var A = [], e = 0; e < arguments.length; e++)
    A[e] = arguments[e];
  if (String.fromCodePoint)
    return String.fromCodePoint.apply(String, A);
  var r = A.length;
  if (!r)
    return "";
  for (var t = [], B = -1, n = ""; ++B < r; ) {
    var s = A[B];
    s <= 65535 ? t.push(s) : (s -= 65536, t.push((s >> 10) + 55296, s % 1024 + 56320)), (B + 1 === r || t.length > 16384) && (n += String.fromCharCode.apply(String, t), t.length = 0);
  }
  return n;
}, cQ = BQ(Ji), dA = "×", kr = "÷", gQ = function(A) {
  return cQ.get(A);
}, wQ = function(A, e, r) {
  var t = r - 2, B = e[t], n = e[r - 1], s = e[r];
  if (n === ht && s === dt)
    return dA;
  if (n === ht || n === dt || n === Mr || s === ht || s === dt || s === Mr)
    return kr;
  if (n === Sr && [Sr, ft, Gr, Tr].indexOf(s) !== -1 || (n === Gr || n === ft) && (s === ft || s === Ht) || (n === Tr || n === Ht) && s === Ht || s === Or || s === xr || s === iQ || n === oQ)
    return dA;
  if (n === Or && s === Vr) {
    for (; B === xr; )
      B = e[--t];
    if (B === Vr)
      return dA;
  }
  if (n === pt && s === pt) {
    for (var o = 0; B === pt; )
      o++, B = e[--t];
    if (o % 2 === 0)
      return dA;
  }
  return kr;
}, UQ = function(A) {
  var e = QQ(A), r = e.length, t = 0, B = 0, n = e.map(gQ);
  return {
    next: function() {
      if (t >= r)
        return { done: !0, value: null };
      for (var s = dA; t < r && (s = wQ(e, n, ++t)) === dA; )
        ;
      if (s !== dA || t === r) {
        var o = aQ.apply(null, e.slice(B, t));
        return B = t, { value: o, done: !1 };
      }
      return { done: !0, value: null };
    }
  };
}, uQ = function(A) {
  for (var e = UQ(A), r = [], t; !(t = e.next()).done; )
    t.value && r.push(t.value.slice());
  return r;
}, CQ = function(A) {
  var e = 123;
  if (A.createRange) {
    var r = A.createRange();
    if (r.getBoundingClientRect) {
      var t = A.createElement("boundtest");
      t.style.height = e + "px", t.style.display = "block", A.body.appendChild(t), r.selectNode(t);
      var B = r.getBoundingClientRect(), n = Math.round(B.height);
      if (A.body.removeChild(t), n === e)
        return !0;
    }
  }
  return !1;
}, lQ = function(A) {
  var e = A.createElement("boundtest");
  e.style.width = "50px", e.style.display = "block", e.style.fontSize = "12px", e.style.letterSpacing = "0px", e.style.wordSpacing = "0px", A.body.appendChild(e);
  var r = A.createRange();
  e.innerHTML = typeof "".repeat == "function" ? "&#128104;".repeat(10) : "";
  var t = e.firstChild, B = Xe(t.data).map(function(i) {
    return x(i);
  }), n = 0, s = {}, o = B.every(function(i, Q) {
    r.setStart(t, n), r.setEnd(t, n + i.length);
    var a = r.getBoundingClientRect();
    n += i.length;
    var c = a.x > s.x || a.y > s.y;
    return s = a, Q === 0 ? !0 : c;
  });
  return A.body.removeChild(e), o;
}, FQ = function() {
  return typeof new Image().crossOrigin < "u";
}, hQ = function() {
  return typeof new XMLHttpRequest().responseType == "string";
}, dQ = function(A) {
  var e = new Image(), r = A.createElement("canvas"), t = r.getContext("2d");
  if (!t)
    return !1;
  e.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
  try {
    t.drawImage(e, 0, 0), r.toDataURL();
  } catch {
    return !1;
  }
  return !0;
}, Rr = function(A) {
  return A[0] === 0 && A[1] === 255 && A[2] === 0 && A[3] === 255;
}, fQ = function(A) {
  var e = A.createElement("canvas"), r = 100;
  e.width = r, e.height = r;
  var t = e.getContext("2d");
  if (!t)
    return Promise.reject(!1);
  t.fillStyle = "rgb(0, 255, 0)", t.fillRect(0, 0, r, r);
  var B = new Image(), n = e.toDataURL();
  B.src = n;
  var s = Pt(r, r, 0, 0, B);
  return t.fillStyle = "red", t.fillRect(0, 0, r, r), Pr(s).then(function(o) {
    t.drawImage(o, 0, 0);
    var i = t.getImageData(0, 0, r, r).data;
    t.fillStyle = "red", t.fillRect(0, 0, r, r);
    var Q = A.createElement("div");
    return Q.style.backgroundImage = "url(" + n + ")", Q.style.height = r + "px", Rr(i) ? Pr(Pt(r, r, 0, 0, Q)) : Promise.reject(!1);
  }).then(function(o) {
    return t.drawImage(o, 0, 0), Rr(t.getImageData(0, 0, r, r).data);
  }).catch(function() {
    return !1;
  });
}, Pt = function(A, e, r, t, B) {
  var n = "http://www.w3.org/2000/svg", s = document.createElementNS(n, "svg"), o = document.createElementNS(n, "foreignObject");
  return s.setAttributeNS(null, "width", A.toString()), s.setAttributeNS(null, "height", e.toString()), o.setAttributeNS(null, "width", "100%"), o.setAttributeNS(null, "height", "100%"), o.setAttributeNS(null, "x", r.toString()), o.setAttributeNS(null, "y", t.toString()), o.setAttributeNS(null, "externalResourcesRequired", "true"), s.appendChild(o), o.appendChild(B), s;
}, Pr = function(A) {
  return new Promise(function(e, r) {
    var t = new Image();
    t.onload = function() {
      return e(t);
    }, t.onerror = r, t.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(A));
  });
}, W = {
  get SUPPORT_RANGE_BOUNDS() {
    var A = CQ(document);
    return Object.defineProperty(W, "SUPPORT_RANGE_BOUNDS", { value: A }), A;
  },
  get SUPPORT_WORD_BREAKING() {
    var A = W.SUPPORT_RANGE_BOUNDS && lQ(document);
    return Object.defineProperty(W, "SUPPORT_WORD_BREAKING", { value: A }), A;
  },
  get SUPPORT_SVG_DRAWING() {
    var A = dQ(document);
    return Object.defineProperty(W, "SUPPORT_SVG_DRAWING", { value: A }), A;
  },
  get SUPPORT_FOREIGNOBJECT_DRAWING() {
    var A = typeof Array.from == "function" && typeof window.fetch == "function" ? fQ(document) : Promise.resolve(!1);
    return Object.defineProperty(W, "SUPPORT_FOREIGNOBJECT_DRAWING", { value: A }), A;
  },
  get SUPPORT_CORS_IMAGES() {
    var A = FQ();
    return Object.defineProperty(W, "SUPPORT_CORS_IMAGES", { value: A }), A;
  },
  get SUPPORT_RESPONSE_TYPE() {
    var A = hQ();
    return Object.defineProperty(W, "SUPPORT_RESPONSE_TYPE", { value: A }), A;
  },
  get SUPPORT_CORS_XHR() {
    var A = "withCredentials" in new XMLHttpRequest();
    return Object.defineProperty(W, "SUPPORT_CORS_XHR", { value: A }), A;
  },
  get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
    var A = !!(typeof Intl < "u" && Intl.Segmenter);
    return Object.defineProperty(W, "SUPPORT_NATIVE_TEXT_SEGMENTATION", { value: A }), A;
  }
}, Ae = (
  /** @class */
  /* @__PURE__ */ function() {
    function A(e, r) {
      this.text = e, this.bounds = r;
    }
    return A;
  }()
), HQ = function(A, e, r, t) {
  var B = IQ(e, r), n = [], s = 0;
  return B.forEach(function(o) {
    if (r.textDecorationLine.length || o.trim().length > 0)
      if (W.SUPPORT_RANGE_BOUNDS) {
        var i = Jr(t, s, o.length).getClientRects();
        if (i.length > 1) {
          var Q = Ar(o), a = 0;
          Q.forEach(function(g) {
            n.push(new Ae(g, pA.fromDOMRectList(A, Jr(t, a + s, g.length).getClientRects()))), a += g.length;
          });
        } else
          n.push(new Ae(o, pA.fromDOMRectList(A, i)));
      } else {
        var c = t.splitText(o.length);
        n.push(new Ae(o, pQ(A, t))), t = c;
      }
    else W.SUPPORT_RANGE_BOUNDS || (t = t.splitText(o.length));
    s += o.length;
  }), n;
}, pQ = function(A, e) {
  var r = e.ownerDocument;
  if (r) {
    var t = r.createElement("html2canvaswrapper");
    t.appendChild(e.cloneNode(!0));
    var B = e.parentNode;
    if (B) {
      B.replaceChild(t, e);
      var n = Zt(A, t);
      return t.firstChild && B.replaceChild(t.firstChild, t), n;
    }
  }
  return pA.EMPTY;
}, Jr = function(A, e, r) {
  var t = A.ownerDocument;
  if (!t)
    throw new Error("Node has no owner document");
  var B = t.createRange();
  return B.setStart(A, e), B.setEnd(A, e + r), B;
}, Ar = function(A) {
  if (W.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
    var e = new Intl.Segmenter(void 0, { granularity: "grapheme" });
    return Array.from(e.segment(A)).map(function(r) {
      return r.segment;
    });
  }
  return uQ(A);
}, EQ = function(A, e) {
  if (W.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
    var r = new Intl.Segmenter(void 0, {
      granularity: "word"
    });
    return Array.from(r.segment(A)).map(function(t) {
      return t.segment;
    });
  }
  return KQ(A, e);
}, IQ = function(A, e) {
  return e.letterSpacing !== 0 ? Ar(A) : EQ(A, e);
}, yQ = [32, 160, 4961, 65792, 65793, 4153, 4241], KQ = function(A, e) {
  for (var r = Bs(A, {
    lineBreak: e.lineBreak,
    wordBreak: e.overflowWrap === "break-word" ? "break-word" : e.wordBreak
  }), t = [], B, n = function() {
    if (B.value) {
      var s = B.value.slice(), o = Xe(s), i = "";
      o.forEach(function(Q) {
        yQ.indexOf(Q) === -1 ? i += x(Q) : (i.length && t.push(i), t.push(x(Q)), i = "");
      }), i.length && t.push(i);
    }
  }; !(B = r.next()).done; )
    n();
  return t;
}, mQ = (
  /** @class */
  /* @__PURE__ */ function() {
    function A(e, r, t) {
      this.text = LQ(r.data, t.textTransform), this.textBounds = HQ(e, this.text, t, r);
    }
    return A;
  }()
), LQ = function(A, e) {
  switch (e) {
    case 1:
      return A.toLowerCase();
    case 3:
      return A.replace(bQ, DQ);
    case 2:
      return A.toUpperCase();
    default:
      return A;
  }
}, bQ = /(^|\s|:|-|\(|\))([a-z])/g, DQ = function(A, e, r) {
  return A.length > 0 ? e + r.toUpperCase() : A;
}, OB = (
  /** @class */
  function(A) {
    tA(e, A);
    function e(r, t) {
      var B = A.call(this, r, t) || this;
      return B.src = t.currentSrc || t.src, B.intrinsicWidth = t.naturalWidth, B.intrinsicHeight = t.naturalHeight, B.context.cache.addImage(B.src), B;
    }
    return e;
  }(nA)
), VB = (
  /** @class */
  function(A) {
    tA(e, A);
    function e(r, t) {
      var B = A.call(this, r, t) || this;
      return B.canvas = t, B.intrinsicWidth = t.width, B.intrinsicHeight = t.height, B;
    }
    return e;
  }(nA)
), kB = (
  /** @class */
  function(A) {
    tA(e, A);
    function e(r, t) {
      var B = A.call(this, r, t) || this, n = new XMLSerializer(), s = Zt(r, t);
      return t.setAttribute("width", s.width + "px"), t.setAttribute("height", s.height + "px"), B.svg = "data:image/svg+xml," + encodeURIComponent(n.serializeToString(t)), B.intrinsicWidth = t.width.baseVal.value, B.intrinsicHeight = t.height.baseVal.value, B.context.cache.addImage(B.svg), B;
    }
    return e;
  }(nA)
), RB = (
  /** @class */
  function(A) {
    tA(e, A);
    function e(r, t) {
      var B = A.call(this, r, t) || this;
      return B.value = t.value, B;
    }
    return e;
  }(nA)
), Jt = (
  /** @class */
  function(A) {
    tA(e, A);
    function e(r, t) {
      var B = A.call(this, r, t) || this;
      return B.start = t.start, B.reversed = typeof t.reversed == "boolean" && t.reversed === !0, B;
    }
    return e;
  }(nA)
), vQ = [
  {
    type: 15,
    flags: 0,
    unit: "px",
    number: 3
  }
], MQ = [
  {
    type: 16,
    flags: 0,
    number: 50
  }
], xQ = function(A) {
  return A.width > A.height ? new pA(A.left + (A.width - A.height) / 2, A.top, A.height, A.height) : A.width < A.height ? new pA(A.left, A.top + (A.height - A.width) / 2, A.width, A.width) : A;
}, SQ = function(A) {
  var e = A.type === GQ ? new Array(A.value.length + 1).join("•") : A.value;
  return e.length === 0 ? A.placeholder || "" : e;
}, Ve = "checkbox", ke = "radio", GQ = "password", Xr = 707406591, er = (
  /** @class */
  function(A) {
    tA(e, A);
    function e(r, t) {
      var B = A.call(this, r, t) || this;
      switch (B.type = t.type.toLowerCase(), B.checked = t.checked, B.value = SQ(t), (B.type === Ve || B.type === ke) && (B.styles.backgroundColor = 3739148031, B.styles.borderTopColor = B.styles.borderRightColor = B.styles.borderBottomColor = B.styles.borderLeftColor = 2779096575, B.styles.borderTopWidth = B.styles.borderRightWidth = B.styles.borderBottomWidth = B.styles.borderLeftWidth = 1, B.styles.borderTopStyle = B.styles.borderRightStyle = B.styles.borderBottomStyle = B.styles.borderLeftStyle = 1, B.styles.backgroundClip = [
        0
        /* BORDER_BOX */
      ], B.styles.backgroundOrigin = [
        0
        /* BORDER_BOX */
      ], B.bounds = xQ(B.bounds)), B.type) {
        case Ve:
          B.styles.borderTopRightRadius = B.styles.borderTopLeftRadius = B.styles.borderBottomRightRadius = B.styles.borderBottomLeftRadius = vQ;
          break;
        case ke:
          B.styles.borderTopRightRadius = B.styles.borderTopLeftRadius = B.styles.borderBottomRightRadius = B.styles.borderBottomLeftRadius = MQ;
          break;
      }
      return B;
    }
    return e;
  }(nA)
), PB = (
  /** @class */
  function(A) {
    tA(e, A);
    function e(r, t) {
      var B = A.call(this, r, t) || this, n = t.options[t.selectedIndex || 0];
      return B.value = n && n.text || "", B;
    }
    return e;
  }(nA)
), JB = (
  /** @class */
  function(A) {
    tA(e, A);
    function e(r, t) {
      var B = A.call(this, r, t) || this;
      return B.value = t.value, B;
    }
    return e;
  }(nA)
), XB = (
  /** @class */
  function(A) {
    tA(e, A);
    function e(r, t) {
      var B = A.call(this, r, t) || this;
      B.src = t.src, B.width = parseInt(t.width, 10) || 0, B.height = parseInt(t.height, 10) || 0, B.backgroundColor = B.styles.backgroundColor;
      try {
        if (t.contentWindow && t.contentWindow.document && t.contentWindow.document.documentElement) {
          B.tree = OQ(r, t.contentWindow.document.documentElement);
          var n = t.contentWindow.document.documentElement ? Er(r, getComputedStyle(t.contentWindow.document.documentElement).backgroundColor) : re.TRANSPARENT, s = t.contentWindow.document.body ? Er(r, getComputedStyle(t.contentWindow.document.body).backgroundColor) : re.TRANSPARENT;
          B.backgroundColor = SA(n) ? SA(s) ? B.styles.backgroundColor : s : n;
        }
      } catch {
      }
      return B;
    }
    return e;
  }(nA)
), TQ = ["OL", "UL", "MENU"], Me = function(A, e, r, t) {
  for (var B = e.firstChild, n = void 0; B; B = n)
    if (n = B.nextSibling, RQ(B) && B.data.trim().length > 0)
      r.textNodes.push(new mQ(A, B, r.styles));
    else if (NB(B))
      if (qQ(B) && B.assignedNodes)
        B.assignedNodes().forEach(function(o) {
          return Me(A, o, r, t);
        });
      else {
        var s = _B(A, B);
        s.styles.isVisible() && (VQ(B, s, t) ? s.flags |= 4 : kQ(s.styles) && (s.flags |= 2), TQ.indexOf(B.tagName) !== -1 && (s.flags |= 8), r.elements.push(s), B.slot, B.shadowRoot ? Me(A, B.shadowRoot, s, t) : !WB(B) && !YB(B) && !ZB(B) && Me(A, B, s, t));
      }
}, _B = function(A, e) {
  return ZQ(e) ? new OB(A, e) : WQ(e) ? new VB(A, e) : YB(e) ? new kB(A, e) : XQ(e) ? new RB(A, e) : _Q(e) ? new Jt(A, e) : NQ(e) ? new er(A, e) : ZB(e) ? new PB(A, e) : WB(e) ? new JB(A, e) : zQ(e) ? new XB(A, e) : new nA(A, e);
}, OQ = function(A, e) {
  var r = _B(A, e);
  return r.flags |= 4, Me(A, e, r, r), r;
}, VQ = function(A, e, r) {
  return e.styles.isPositionedWithZIndex() || e.styles.opacity < 1 || e.styles.isTransformed() || YQ(A) && r.styles.isTransparent();
}, kQ = function(A) {
  return A.isPositioned() || A.isFloating();
}, RQ = function(A) {
  return A.nodeType === Node.TEXT_NODE;
}, NB = function(A) {
  return A.nodeType === Node.ELEMENT_NODE;
}, PQ = function(A) {
  return NB(A) && typeof A.style < "u" && !JQ(A);
}, JQ = function(A) {
  return typeof A.className == "object";
}, XQ = function(A) {
  return A.tagName === "LI";
}, _Q = function(A) {
  return A.tagName === "OL";
}, NQ = function(A) {
  return A.tagName === "INPUT";
}, YB = function(A) {
  return A.tagName === "svg";
}, YQ = function(A) {
  return A.tagName === "BODY";
}, WQ = function(A) {
  return A.tagName === "CANVAS";
}, ZQ = function(A) {
  return A.tagName === "IMG";
}, zQ = function(A) {
  return A.tagName === "IFRAME";
}, WB = function(A) {
  return A.tagName === "TEXTAREA";
}, ZB = function(A) {
  return A.tagName === "SELECT";
}, qQ = function(A) {
  return A.tagName === "SLOT";
}, _r = {
  integers: [1e3, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
  values: ["M", "CM", "D", "CD", "C", "XC", "L", "XL", "X", "IX", "V", "IV", "I"]
}, Nr = {
  integers: [
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    900,
    800,
    700,
    600,
    500,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "Ք",
    "Փ",
    "Ւ",
    "Ց",
    "Ր",
    "Տ",
    "Վ",
    "Ս",
    "Ռ",
    "Ջ",
    "Պ",
    "Չ",
    "Ո",
    "Շ",
    "Ն",
    "Յ",
    "Մ",
    "Ճ",
    "Ղ",
    "Ձ",
    "Հ",
    "Կ",
    "Ծ",
    "Խ",
    "Լ",
    "Ի",
    "Ժ",
    "Թ",
    "Ը",
    "Է",
    "Զ",
    "Ե",
    "Դ",
    "Գ",
    "Բ",
    "Ա"
  ]
}, jQ = {
  integers: [
    1e4,
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    19,
    18,
    17,
    16,
    15,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "י׳",
    "ט׳",
    "ח׳",
    "ז׳",
    "ו׳",
    "ה׳",
    "ד׳",
    "ג׳",
    "ב׳",
    "א׳",
    "ת",
    "ש",
    "ר",
    "ק",
    "צ",
    "פ",
    "ע",
    "ס",
    "נ",
    "מ",
    "ל",
    "כ",
    "יט",
    "יח",
    "יז",
    "טז",
    "טו",
    "י",
    "ט",
    "ח",
    "ז",
    "ו",
    "ה",
    "ד",
    "ג",
    "ב",
    "א"
  ]
}, $Q = {
  integers: [
    1e4,
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    900,
    800,
    700,
    600,
    500,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "ჵ",
    "ჰ",
    "ჯ",
    "ჴ",
    "ხ",
    "ჭ",
    "წ",
    "ძ",
    "ც",
    "ჩ",
    "შ",
    "ყ",
    "ღ",
    "ქ",
    "ფ",
    "ჳ",
    "ტ",
    "ს",
    "რ",
    "ჟ",
    "პ",
    "ო",
    "ჲ",
    "ნ",
    "მ",
    "ლ",
    "კ",
    "ი",
    "თ",
    "ჱ",
    "ზ",
    "ვ",
    "ე",
    "დ",
    "გ",
    "ბ",
    "ა"
  ]
}, LA = function(A, e, r, t, B, n) {
  return A < e || A > r ? tr(A, B, n.length > 0) : t.integers.reduce(function(s, o, i) {
    for (; A >= o; )
      A -= o, s += t.values[i];
    return s;
  }, "") + n;
}, zB = function(A, e, r, t) {
  var B = "";
  do
    r || A--, B = t(A) + B, A /= e;
  while (A * e >= e);
  return B;
}, M = function(A, e, r, t, B) {
  var n = r - e + 1;
  return (A < 0 ? "-" : "") + (zB(Math.abs(A), n, t, function(s) {
    return x(Math.floor(s % n) + e);
  }) + B);
}, FA = function(A, e, r) {
  r === void 0 && (r = ". ");
  var t = e.length;
  return zB(Math.abs(A), t, !1, function(B) {
    return e[Math.floor(B % t)];
  }) + r;
}, vA = 1, aA = 2, cA = 4, qA = 8, iA = function(A, e, r, t, B, n) {
  if (A < -9999 || A > 9999)
    return tr(A, 4, B.length > 0);
  var s = Math.abs(A), o = B;
  if (s === 0)
    return e[0] + o;
  for (var i = 0; s > 0 && i <= 4; i++) {
    var Q = s % 10;
    Q === 0 && T(n, vA) && o !== "" ? o = e[Q] + o : Q > 1 || Q === 1 && i === 0 || Q === 1 && i === 1 && T(n, aA) || Q === 1 && i === 1 && T(n, cA) && A > 100 || Q === 1 && i > 1 && T(n, qA) ? o = e[Q] + (i > 0 ? r[i - 1] : "") + o : Q === 1 && i > 0 && (o = r[i - 1] + o), s = Math.floor(s / 10);
  }
  return (A < 0 ? t : "") + o;
}, Yr = "十百千萬", Wr = "拾佰仟萬", Zr = "マイナス", Et = "마이너스", tr = function(A, e, r) {
  var t = r ? ". " : "", B = r ? "、" : "", n = r ? ", " : "", s = r ? " " : "";
  switch (e) {
    case 0:
      return "•" + s;
    case 1:
      return "◦" + s;
    case 2:
      return "◾" + s;
    case 5:
      var o = M(A, 48, 57, !0, t);
      return o.length < 4 ? "0" + o : o;
    case 4:
      return FA(A, "〇一二三四五六七八九", B);
    case 6:
      return LA(A, 1, 3999, _r, 3, t).toLowerCase();
    case 7:
      return LA(A, 1, 3999, _r, 3, t);
    case 8:
      return M(A, 945, 969, !1, t);
    case 9:
      return M(A, 97, 122, !1, t);
    case 10:
      return M(A, 65, 90, !1, t);
    case 11:
      return M(A, 1632, 1641, !0, t);
    case 12:
    case 49:
      return LA(A, 1, 9999, Nr, 3, t);
    case 35:
      return LA(A, 1, 9999, Nr, 3, t).toLowerCase();
    case 13:
      return M(A, 2534, 2543, !0, t);
    case 14:
    case 30:
      return M(A, 6112, 6121, !0, t);
    case 15:
      return FA(A, "子丑寅卯辰巳午未申酉戌亥", B);
    case 16:
      return FA(A, "甲乙丙丁戊己庚辛壬癸", B);
    case 17:
    case 48:
      return iA(A, "零一二三四五六七八九", Yr, "負", B, aA | cA | qA);
    case 47:
      return iA(A, "零壹貳參肆伍陸柒捌玖", Wr, "負", B, vA | aA | cA | qA);
    case 42:
      return iA(A, "零一二三四五六七八九", Yr, "负", B, aA | cA | qA);
    case 41:
      return iA(A, "零壹贰叁肆伍陆柒捌玖", Wr, "负", B, vA | aA | cA | qA);
    case 26:
      return iA(A, "〇一二三四五六七八九", "十百千万", Zr, B, 0);
    case 25:
      return iA(A, "零壱弐参四伍六七八九", "拾百千万", Zr, B, vA | aA | cA);
    case 31:
      return iA(A, "영일이삼사오육칠팔구", "십백천만", Et, n, vA | aA | cA);
    case 33:
      return iA(A, "零一二三四五六七八九", "十百千萬", Et, n, 0);
    case 32:
      return iA(A, "零壹貳參四五六七八九", "拾百千", Et, n, vA | aA | cA);
    case 18:
      return M(A, 2406, 2415, !0, t);
    case 20:
      return LA(A, 1, 19999, $Q, 3, t);
    case 21:
      return M(A, 2790, 2799, !0, t);
    case 22:
      return M(A, 2662, 2671, !0, t);
    case 22:
      return LA(A, 1, 10999, jQ, 3, t);
    case 23:
      return FA(A, "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん");
    case 24:
      return FA(A, "いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす");
    case 27:
      return M(A, 3302, 3311, !0, t);
    case 28:
      return FA(A, "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン", B);
    case 29:
      return FA(A, "イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス", B);
    case 34:
      return M(A, 3792, 3801, !0, t);
    case 37:
      return M(A, 6160, 6169, !0, t);
    case 38:
      return M(A, 4160, 4169, !0, t);
    case 39:
      return M(A, 2918, 2927, !0, t);
    case 40:
      return M(A, 1776, 1785, !0, t);
    case 43:
      return M(A, 3046, 3055, !0, t);
    case 44:
      return M(A, 3174, 3183, !0, t);
    case 45:
      return M(A, 3664, 3673, !0, t);
    case 46:
      return M(A, 3872, 3881, !0, t);
    case 3:
    default:
      return M(A, 48, 57, !0, t);
  }
}, zr;
(function(A) {
  A[A.BEFORE = 0] = "BEFORE", A[A.AFTER = 1] = "AFTER";
})(zr || (zr = {}));
var Aa = (
  /** @class */
  function() {
    function A() {
    }
    return A.getOrigin = function(e) {
      var r = A._link;
      return r ? (r.href = e, r.href = r.href, r.protocol + r.hostname + r.port) : "about:blank";
    }, A.isSameOrigin = function(e) {
      return A.getOrigin(e) === A._origin;
    }, A.setContext = function(e) {
      A._link = e.document.createElement("a"), A._origin = A.getOrigin(e.location.href);
    }, A._origin = "about:blank", A;
  }()
), u = (
  /** @class */
  function() {
    function A(e, r) {
      this.type = 0, this.x = e, this.y = r;
    }
    return A.prototype.add = function(e, r) {
      return new A(this.x + e, this.y + r);
    }, A;
  }()
), bA = function(A, e, r) {
  return new u(A.x + (e.x - A.x) * r, A.y + (e.y - A.y) * r);
}, ye = (
  /** @class */
  function() {
    function A(e, r, t, B) {
      this.type = 1, this.start = e, this.startControl = r, this.endControl = t, this.end = B;
    }
    return A.prototype.subdivide = function(e, r) {
      var t = bA(this.start, this.startControl, e), B = bA(this.startControl, this.endControl, e), n = bA(this.endControl, this.end, e), s = bA(t, B, e), o = bA(B, n, e), i = bA(s, o, e);
      return r ? new A(this.start, t, s, i) : new A(i, o, n, this.end);
    }, A.prototype.add = function(e, r) {
      return new A(this.start.add(e, r), this.startControl.add(e, r), this.endControl.add(e, r), this.end.add(e, r));
    }, A.prototype.reverse = function() {
      return new A(this.end, this.endControl, this.startControl, this.start);
    }, A;
  }()
), q = function(A) {
  return A.type === 1;
}, ea = (
  /** @class */
  /* @__PURE__ */ function() {
    function A(e) {
      var r = e.styles, t = e.bounds, B = ZA(r.borderTopLeftRadius, t.width, t.height), n = B[0], s = B[1], o = ZA(r.borderTopRightRadius, t.width, t.height), i = o[0], Q = o[1], a = ZA(r.borderBottomRightRadius, t.width, t.height), c = a[0], g = a[1], U = ZA(r.borderBottomLeftRadius, t.width, t.height), w = U[0], C = U[1], I = [];
      I.push((n + i) / t.width), I.push((w + c) / t.width), I.push((s + C) / t.height), I.push((Q + g) / t.height);
      var h = Math.max.apply(Math, I);
      h > 1 && (n /= h, s /= h, i /= h, Q /= h, c /= h, g /= h, w /= h, C /= h);
      var d = t.width - i, L = t.height - g, y = t.width - c, f = t.height - C, l = r.borderTopWidth, E = r.borderRightWidth, p = r.borderBottomWidth, H = r.borderLeftWidth, G = b(r.paddingTop, e.bounds.width), sA = b(r.paddingRight, e.bounds.width), Z = b(r.paddingBottom, e.bounds.width), m = b(r.paddingLeft, e.bounds.width);
      this.topLeftBorderDoubleOuterBox = n > 0 || s > 0 ? D(t.left + H / 3, t.top + l / 3, n - H / 3, s - l / 3, K.TOP_LEFT) : new u(t.left + H / 3, t.top + l / 3), this.topRightBorderDoubleOuterBox = n > 0 || s > 0 ? D(t.left + d, t.top + l / 3, i - E / 3, Q - l / 3, K.TOP_RIGHT) : new u(t.left + t.width - E / 3, t.top + l / 3), this.bottomRightBorderDoubleOuterBox = c > 0 || g > 0 ? D(t.left + y, t.top + L, c - E / 3, g - p / 3, K.BOTTOM_RIGHT) : new u(t.left + t.width - E / 3, t.top + t.height - p / 3), this.bottomLeftBorderDoubleOuterBox = w > 0 || C > 0 ? D(t.left + H / 3, t.top + f, w - H / 3, C - p / 3, K.BOTTOM_LEFT) : new u(t.left + H / 3, t.top + t.height - p / 3), this.topLeftBorderDoubleInnerBox = n > 0 || s > 0 ? D(t.left + H * 2 / 3, t.top + l * 2 / 3, n - H * 2 / 3, s - l * 2 / 3, K.TOP_LEFT) : new u(t.left + H * 2 / 3, t.top + l * 2 / 3), this.topRightBorderDoubleInnerBox = n > 0 || s > 0 ? D(t.left + d, t.top + l * 2 / 3, i - E * 2 / 3, Q - l * 2 / 3, K.TOP_RIGHT) : new u(t.left + t.width - E * 2 / 3, t.top + l * 2 / 3), this.bottomRightBorderDoubleInnerBox = c > 0 || g > 0 ? D(t.left + y, t.top + L, c - E * 2 / 3, g - p * 2 / 3, K.BOTTOM_RIGHT) : new u(t.left + t.width - E * 2 / 3, t.top + t.height - p * 2 / 3), this.bottomLeftBorderDoubleInnerBox = w > 0 || C > 0 ? D(t.left + H * 2 / 3, t.top + f, w - H * 2 / 3, C - p * 2 / 3, K.BOTTOM_LEFT) : new u(t.left + H * 2 / 3, t.top + t.height - p * 2 / 3), this.topLeftBorderStroke = n > 0 || s > 0 ? D(t.left + H / 2, t.top + l / 2, n - H / 2, s - l / 2, K.TOP_LEFT) : new u(t.left + H / 2, t.top + l / 2), this.topRightBorderStroke = n > 0 || s > 0 ? D(t.left + d, t.top + l / 2, i - E / 2, Q - l / 2, K.TOP_RIGHT) : new u(t.left + t.width - E / 2, t.top + l / 2), this.bottomRightBorderStroke = c > 0 || g > 0 ? D(t.left + y, t.top + L, c - E / 2, g - p / 2, K.BOTTOM_RIGHT) : new u(t.left + t.width - E / 2, t.top + t.height - p / 2), this.bottomLeftBorderStroke = w > 0 || C > 0 ? D(t.left + H / 2, t.top + f, w - H / 2, C - p / 2, K.BOTTOM_LEFT) : new u(t.left + H / 2, t.top + t.height - p / 2), this.topLeftBorderBox = n > 0 || s > 0 ? D(t.left, t.top, n, s, K.TOP_LEFT) : new u(t.left, t.top), this.topRightBorderBox = i > 0 || Q > 0 ? D(t.left + d, t.top, i, Q, K.TOP_RIGHT) : new u(t.left + t.width, t.top), this.bottomRightBorderBox = c > 0 || g > 0 ? D(t.left + y, t.top + L, c, g, K.BOTTOM_RIGHT) : new u(t.left + t.width, t.top + t.height), this.bottomLeftBorderBox = w > 0 || C > 0 ? D(t.left, t.top + f, w, C, K.BOTTOM_LEFT) : new u(t.left, t.top + t.height), this.topLeftPaddingBox = n > 0 || s > 0 ? D(t.left + H, t.top + l, Math.max(0, n - H), Math.max(0, s - l), K.TOP_LEFT) : new u(t.left + H, t.top + l), this.topRightPaddingBox = i > 0 || Q > 0 ? D(t.left + Math.min(d, t.width - E), t.top + l, d > t.width + E ? 0 : Math.max(0, i - E), Math.max(0, Q - l), K.TOP_RIGHT) : new u(t.left + t.width - E, t.top + l), this.bottomRightPaddingBox = c > 0 || g > 0 ? D(t.left + Math.min(y, t.width - H), t.top + Math.min(L, t.height - p), Math.max(0, c - E), Math.max(0, g - p), K.BOTTOM_RIGHT) : new u(t.left + t.width - E, t.top + t.height - p), this.bottomLeftPaddingBox = w > 0 || C > 0 ? D(t.left + H, t.top + Math.min(f, t.height - p), Math.max(0, w - H), Math.max(0, C - p), K.BOTTOM_LEFT) : new u(t.left + H, t.top + t.height - p), this.topLeftContentBox = n > 0 || s > 0 ? D(t.left + H + m, t.top + l + G, Math.max(0, n - (H + m)), Math.max(0, s - (l + G)), K.TOP_LEFT) : new u(t.left + H + m, t.top + l + G), this.topRightContentBox = i > 0 || Q > 0 ? D(t.left + Math.min(d, t.width + H + m), t.top + l + G, d > t.width + H + m ? 0 : i - H + m, Q - (l + G), K.TOP_RIGHT) : new u(t.left + t.width - (E + sA), t.top + l + G), this.bottomRightContentBox = c > 0 || g > 0 ? D(t.left + Math.min(y, t.width - (H + m)), t.top + Math.min(L, t.height + l + G), Math.max(0, c - (E + sA)), g - (p + Z), K.BOTTOM_RIGHT) : new u(t.left + t.width - (E + sA), t.top + t.height - (p + Z)), this.bottomLeftContentBox = w > 0 || C > 0 ? D(t.left + H + m, t.top + f, Math.max(0, w - (H + m)), C - (p + Z), K.BOTTOM_LEFT) : new u(t.left + H + m, t.top + t.height - (p + Z));
    }
    return A;
  }()
), K;
(function(A) {
  A[A.TOP_LEFT = 0] = "TOP_LEFT", A[A.TOP_RIGHT = 1] = "TOP_RIGHT", A[A.BOTTOM_RIGHT = 2] = "BOTTOM_RIGHT", A[A.BOTTOM_LEFT = 3] = "BOTTOM_LEFT";
})(K || (K = {}));
var D = function(A, e, r, t, B) {
  var n = 4 * ((Math.sqrt(2) - 1) / 3), s = r * n, o = t * n, i = A + r, Q = e + t;
  switch (B) {
    case K.TOP_LEFT:
      return new ye(new u(A, Q), new u(A, Q - o), new u(i - s, e), new u(i, e));
    case K.TOP_RIGHT:
      return new ye(new u(A, e), new u(A + s, e), new u(i, Q - o), new u(i, Q));
    case K.BOTTOM_RIGHT:
      return new ye(new u(i, e), new u(i, e + o), new u(A + s, Q), new u(A, Q));
    case K.BOTTOM_LEFT:
    default:
      return new ye(new u(i, Q), new u(i - s, Q), new u(A, e + o), new u(A, e));
  }
}, Re = function(A) {
  return [A.topLeftBorderBox, A.topRightBorderBox, A.bottomRightBorderBox, A.bottomLeftBorderBox];
}, ta = function(A) {
  return [
    A.topLeftContentBox,
    A.topRightContentBox,
    A.bottomRightContentBox,
    A.bottomLeftContentBox
  ];
}, Pe = function(A) {
  return [
    A.topLeftPaddingBox,
    A.topRightPaddingBox,
    A.bottomRightPaddingBox,
    A.bottomLeftPaddingBox
  ];
}, ra = (
  /** @class */
  /* @__PURE__ */ function() {
    function A(e, r, t) {
      this.offsetX = e, this.offsetY = r, this.matrix = t, this.type = 0, this.target = 6;
    }
    return A;
  }()
), Ke = (
  /** @class */
  /* @__PURE__ */ function() {
    function A(e, r) {
      this.path = e, this.target = r, this.type = 1;
    }
    return A;
  }()
), Ba = (
  /** @class */
  /* @__PURE__ */ function() {
    function A(e) {
      this.opacity = e, this.type = 2, this.target = 6;
    }
    return A;
  }()
), na = function(A) {
  return A.type === 0;
}, qB = function(A) {
  return A.type === 1;
}, sa = function(A) {
  return A.type === 2;
}, qr = function(A, e) {
  return A.length === e.length ? A.some(function(r, t) {
    return r === e[t];
  }) : !1;
}, oa = function(A, e, r, t, B) {
  return A.map(function(n, s) {
    switch (s) {
      case 0:
        return n.add(e, r);
      case 1:
        return n.add(e + t, r);
      case 2:
        return n.add(e + t, r + B);
      case 3:
        return n.add(e, r + B);
    }
    return n;
  });
}, jB = (
  /** @class */
  /* @__PURE__ */ function() {
    function A(e) {
      this.element = e, this.inlineLevel = [], this.nonInlineLevel = [], this.negativeZIndex = [], this.zeroOrAutoZIndexOrTransformedOrOpacity = [], this.positiveZIndex = [], this.nonPositionedFloats = [], this.nonPositionedInlineLevel = [];
    }
    return A;
  }()
), $B = (
  /** @class */
  function() {
    function A(e, r) {
      if (this.container = e, this.parent = r, this.effects = [], this.curves = new ea(this.container), this.container.styles.opacity < 1 && this.effects.push(new Ba(this.container.styles.opacity)), this.container.styles.transform !== null) {
        var t = this.container.bounds.left + this.container.styles.transformOrigin[0].number, B = this.container.bounds.top + this.container.styles.transformOrigin[1].number, n = this.container.styles.transform;
        this.effects.push(new ra(t, B, n));
      }
      if (this.container.styles.overflowX !== 0) {
        var s = Re(this.curves), o = Pe(this.curves);
        qr(s, o) ? this.effects.push(new Ke(
          s,
          6
          /* CONTENT */
        )) : (this.effects.push(new Ke(
          s,
          2
          /* BACKGROUND_BORDERS */
        )), this.effects.push(new Ke(
          o,
          4
          /* CONTENT */
        )));
      }
    }
    return A.prototype.getEffects = function(e) {
      for (var r = [
        2,
        3
        /* FIXED */
      ].indexOf(this.container.styles.position) === -1, t = this.parent, B = this.effects.slice(0); t; ) {
        var n = t.effects.filter(function(i) {
          return !qB(i);
        });
        if (r || t.container.styles.position !== 0 || !t.parent) {
          if (B.unshift.apply(B, n), r = [
            2,
            3
            /* FIXED */
          ].indexOf(t.container.styles.position) === -1, t.container.styles.overflowX !== 0) {
            var s = Re(t.curves), o = Pe(t.curves);
            qr(s, o) || B.unshift(new Ke(
              o,
              6
              /* CONTENT */
            ));
          }
        } else
          B.unshift.apply(B, n);
        t = t.parent;
      }
      return B.filter(function(i) {
        return T(i.target, e);
      });
    }, A;
  }()
), Xt = function(A, e, r, t) {
  A.container.elements.forEach(function(B) {
    var n = T(
      B.flags,
      4
      /* CREATES_REAL_STACKING_CONTEXT */
    ), s = T(
      B.flags,
      2
      /* CREATES_STACKING_CONTEXT */
    ), o = new $B(B, A);
    T(
      B.styles.display,
      2048
      /* LIST_ITEM */
    ) && t.push(o);
    var i = T(
      B.flags,
      8
      /* IS_LIST_OWNER */
    ) ? [] : t;
    if (n || s) {
      var Q = n || B.styles.isPositioned() ? r : e, a = new jB(o);
      if (B.styles.isPositioned() || B.styles.opacity < 1 || B.styles.isTransformed()) {
        var c = B.styles.zIndex.order;
        if (c < 0) {
          var g = 0;
          Q.negativeZIndex.some(function(w, C) {
            return c > w.element.container.styles.zIndex.order ? (g = C, !1) : g > 0;
          }), Q.negativeZIndex.splice(g, 0, a);
        } else if (c > 0) {
          var U = 0;
          Q.positiveZIndex.some(function(w, C) {
            return c >= w.element.container.styles.zIndex.order ? (U = C + 1, !1) : U > 0;
          }), Q.positiveZIndex.splice(U, 0, a);
        } else
          Q.zeroOrAutoZIndexOrTransformedOrOpacity.push(a);
      } else
        B.styles.isFloating() ? Q.nonPositionedFloats.push(a) : Q.nonPositionedInlineLevel.push(a);
      Xt(o, a, n ? a : r, i);
    } else
      B.styles.isInlineLevel() ? e.inlineLevel.push(o) : e.nonInlineLevel.push(o), Xt(o, e, r, i);
    T(
      B.flags,
      8
      /* IS_LIST_OWNER */
    ) && An(B, i);
  });
}, An = function(A, e) {
  for (var r = A instanceof Jt ? A.start : 1, t = A instanceof Jt ? A.reversed : !1, B = 0; B < e.length; B++) {
    var n = e[B];
    n.container instanceof RB && typeof n.container.value == "number" && n.container.value !== 0 && (r = n.container.value), n.listValue = tr(r, n.container.styles.listStyleType, !0), r += t ? -1 : 1;
  }
}, ia = function(A) {
  var e = new $B(A, null), r = new jB(e), t = [];
  return Xt(e, r, r, t), An(e.container, t), r;
}, jr = function(A, e) {
  switch (e) {
    case 0:
      return $(A.topLeftBorderBox, A.topLeftPaddingBox, A.topRightBorderBox, A.topRightPaddingBox);
    case 1:
      return $(A.topRightBorderBox, A.topRightPaddingBox, A.bottomRightBorderBox, A.bottomRightPaddingBox);
    case 2:
      return $(A.bottomRightBorderBox, A.bottomRightPaddingBox, A.bottomLeftBorderBox, A.bottomLeftPaddingBox);
    case 3:
    default:
      return $(A.bottomLeftBorderBox, A.bottomLeftPaddingBox, A.topLeftBorderBox, A.topLeftPaddingBox);
  }
}, Qa = function(A, e) {
  switch (e) {
    case 0:
      return $(A.topLeftBorderBox, A.topLeftBorderDoubleOuterBox, A.topRightBorderBox, A.topRightBorderDoubleOuterBox);
    case 1:
      return $(A.topRightBorderBox, A.topRightBorderDoubleOuterBox, A.bottomRightBorderBox, A.bottomRightBorderDoubleOuterBox);
    case 2:
      return $(A.bottomRightBorderBox, A.bottomRightBorderDoubleOuterBox, A.bottomLeftBorderBox, A.bottomLeftBorderDoubleOuterBox);
    case 3:
    default:
      return $(A.bottomLeftBorderBox, A.bottomLeftBorderDoubleOuterBox, A.topLeftBorderBox, A.topLeftBorderDoubleOuterBox);
  }
}, aa = function(A, e) {
  switch (e) {
    case 0:
      return $(A.topLeftBorderDoubleInnerBox, A.topLeftPaddingBox, A.topRightBorderDoubleInnerBox, A.topRightPaddingBox);
    case 1:
      return $(A.topRightBorderDoubleInnerBox, A.topRightPaddingBox, A.bottomRightBorderDoubleInnerBox, A.bottomRightPaddingBox);
    case 2:
      return $(A.bottomRightBorderDoubleInnerBox, A.bottomRightPaddingBox, A.bottomLeftBorderDoubleInnerBox, A.bottomLeftPaddingBox);
    case 3:
    default:
      return $(A.bottomLeftBorderDoubleInnerBox, A.bottomLeftPaddingBox, A.topLeftBorderDoubleInnerBox, A.topLeftPaddingBox);
  }
}, ca = function(A, e) {
  switch (e) {
    case 0:
      return me(A.topLeftBorderStroke, A.topRightBorderStroke);
    case 1:
      return me(A.topRightBorderStroke, A.bottomRightBorderStroke);
    case 2:
      return me(A.bottomRightBorderStroke, A.bottomLeftBorderStroke);
    case 3:
    default:
      return me(A.bottomLeftBorderStroke, A.topLeftBorderStroke);
  }
}, me = function(A, e) {
  var r = [];
  return q(A) ? r.push(A.subdivide(0.5, !1)) : r.push(A), q(e) ? r.push(e.subdivide(0.5, !0)) : r.push(e), r;
}, $ = function(A, e, r, t) {
  var B = [];
  return q(A) ? B.push(A.subdivide(0.5, !1)) : B.push(A), q(r) ? B.push(r.subdivide(0.5, !0)) : B.push(r), q(t) ? B.push(t.subdivide(0.5, !0).reverse()) : B.push(t), q(e) ? B.push(e.subdivide(0.5, !1).reverse()) : B.push(e), B;
}, en = function(A) {
  var e = A.bounds, r = A.styles;
  return e.add(r.borderLeftWidth, r.borderTopWidth, -(r.borderRightWidth + r.borderLeftWidth), -(r.borderTopWidth + r.borderBottomWidth));
}, Je = function(A) {
  var e = A.styles, r = A.bounds, t = b(e.paddingLeft, r.width), B = b(e.paddingRight, r.width), n = b(e.paddingTop, r.width), s = b(e.paddingBottom, r.width);
  return r.add(t + e.borderLeftWidth, n + e.borderTopWidth, -(e.borderRightWidth + e.borderLeftWidth + t + B), -(e.borderTopWidth + e.borderBottomWidth + n + s));
}, ga = function(A, e) {
  return A === 0 ? e.bounds : A === 2 ? Je(e) : en(e);
}, wa = function(A, e) {
  return A === 0 ? e.bounds : A === 2 ? Je(e) : en(e);
}, It = function(A, e, r) {
  var t = ga(MA(A.styles.backgroundOrigin, e), A), B = wa(MA(A.styles.backgroundClip, e), A), n = Ua(MA(A.styles.backgroundSize, e), r, t), s = n[0], o = n[1], i = ZA(MA(A.styles.backgroundPosition, e), t.width - s, t.height - o), Q = ua(MA(A.styles.backgroundRepeat, e), i, n, t, B), a = Math.round(t.left + i[0]), c = Math.round(t.top + i[1]);
  return [Q, a, c, s, o];
}, DA = function(A) {
  return v(A) && A.value === GA.AUTO;
}, Le = function(A) {
  return typeof A == "number";
}, Ua = function(A, e, r) {
  var t = e[0], B = e[1], n = e[2], s = A[0], o = A[1];
  if (!s)
    return [0, 0];
  if (S(s) && o && S(o))
    return [b(s, r.width), b(o, r.height)];
  var i = Le(n);
  if (v(s) && (s.value === GA.CONTAIN || s.value === GA.COVER)) {
    if (Le(n)) {
      var Q = r.width / r.height;
      return Q < n != (s.value === GA.COVER) ? [r.width, r.width / n] : [r.height * n, r.height];
    }
    return [r.width, r.height];
  }
  var a = Le(t), c = Le(B), g = a || c;
  if (DA(s) && (!o || DA(o))) {
    if (a && c)
      return [t, B];
    if (!i && !g)
      return [r.width, r.height];
    if (g && i) {
      var U = a ? t : B * n, w = c ? B : t / n;
      return [U, w];
    }
    var C = a ? t : r.width, I = c ? B : r.height;
    return [C, I];
  }
  if (i) {
    var h = 0, d = 0;
    return S(s) ? h = b(s, r.width) : S(o) && (d = b(o, r.height)), DA(s) ? h = d * n : (!o || DA(o)) && (d = h / n), [h, d];
  }
  var L = null, y = null;
  if (S(s) ? L = b(s, r.width) : o && S(o) && (y = b(o, r.height)), L !== null && (!o || DA(o)) && (y = a && c ? L / t * B : r.height), y !== null && DA(s) && (L = a && c ? y / B * t : r.width), L !== null && y !== null)
    return [L, y];
  throw new Error("Unable to calculate background-size for element");
}, MA = function(A, e) {
  var r = A[e];
  return typeof r > "u" ? A[0] : r;
}, ua = function(A, e, r, t, B) {
  var n = e[0], s = e[1], o = r[0], i = r[1];
  switch (A) {
    case 2:
      return [
        new u(Math.round(t.left), Math.round(t.top + s)),
        new u(Math.round(t.left + t.width), Math.round(t.top + s)),
        new u(Math.round(t.left + t.width), Math.round(i + t.top + s)),
        new u(Math.round(t.left), Math.round(i + t.top + s))
      ];
    case 3:
      return [
        new u(Math.round(t.left + n), Math.round(t.top)),
        new u(Math.round(t.left + n + o), Math.round(t.top)),
        new u(Math.round(t.left + n + o), Math.round(t.height + t.top)),
        new u(Math.round(t.left + n), Math.round(t.height + t.top))
      ];
    case 1:
      return [
        new u(Math.round(t.left + n), Math.round(t.top + s)),
        new u(Math.round(t.left + n + o), Math.round(t.top + s)),
        new u(Math.round(t.left + n + o), Math.round(t.top + s + i)),
        new u(Math.round(t.left + n), Math.round(t.top + s + i))
      ];
    default:
      return [
        new u(Math.round(B.left), Math.round(B.top)),
        new u(Math.round(B.left + B.width), Math.round(B.top)),
        new u(Math.round(B.left + B.width), Math.round(B.height + B.top)),
        new u(Math.round(B.left), Math.round(B.height + B.top))
      ];
  }
}, Ca = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", $r = "Hidden Text", la = (
  /** @class */
  function() {
    function A(e) {
      this._data = {}, this._document = e;
    }
    return A.prototype.parseMetrics = function(e, r) {
      var t = this._document.createElement("div"), B = this._document.createElement("img"), n = this._document.createElement("span"), s = this._document.body;
      t.style.visibility = "hidden", t.style.fontFamily = e, t.style.fontSize = r, t.style.margin = "0", t.style.padding = "0", t.style.whiteSpace = "nowrap", s.appendChild(t), B.src = Ca, B.width = 1, B.height = 1, B.style.margin = "0", B.style.padding = "0", B.style.verticalAlign = "baseline", n.style.fontFamily = e, n.style.fontSize = r, n.style.margin = "0", n.style.padding = "0", n.appendChild(this._document.createTextNode($r)), t.appendChild(n), t.appendChild(B);
      var o = B.offsetTop - n.offsetTop + 2;
      t.removeChild(n), t.appendChild(this._document.createTextNode($r)), t.style.lineHeight = "normal", B.style.verticalAlign = "super";
      var i = B.offsetTop - t.offsetTop + 2;
      return s.removeChild(t), { baseline: o, middle: i };
    }, A.prototype.getMetrics = function(e, r) {
      var t = e + " " + r;
      return typeof this._data[t] > "u" && (this._data[t] = this.parseMetrics(e, r)), this._data[t];
    }, A;
  }()
), tn = (
  /** @class */
  /* @__PURE__ */ function() {
    function A(e, r) {
      this.context = e, this.options = r;
    }
    return A;
  }()
), Fa = 1e4;
(function(A) {
  tA(e, A);
  function e(r, t) {
    var B = A.call(this, r, t) || this;
    return B._activeEffects = [], B.canvas = t.canvas ? t.canvas : document.createElement("canvas"), B.ctx = B.canvas.getContext("2d"), t.canvas || (B.canvas.width = Math.floor(t.width * t.scale), B.canvas.height = Math.floor(t.height * t.scale), B.canvas.style.width = t.width + "px", B.canvas.style.height = t.height + "px"), B.fontMetrics = new la(document), B.ctx.scale(B.options.scale, B.options.scale), B.ctx.translate(-t.x, -t.y), B.ctx.textBaseline = "bottom", B._activeEffects = [], B.context.logger.debug("Canvas renderer initialized (" + t.width + "x" + t.height + ") with scale " + t.scale), B;
  }
  return e.prototype.applyEffects = function(r) {
    for (var t = this; this._activeEffects.length; )
      this.popEffect();
    r.forEach(function(B) {
      return t.applyEffect(B);
    });
  }, e.prototype.applyEffect = function(r) {
    this.ctx.save(), sa(r) && (this.ctx.globalAlpha = r.opacity), na(r) && (this.ctx.translate(r.offsetX, r.offsetY), this.ctx.transform(r.matrix[0], r.matrix[1], r.matrix[2], r.matrix[3], r.matrix[4], r.matrix[5]), this.ctx.translate(-r.offsetX, -r.offsetY)), qB(r) && (this.path(r.path), this.ctx.clip()), this._activeEffects.push(r);
  }, e.prototype.popEffect = function() {
    this._activeEffects.pop(), this.ctx.restore();
  }, e.prototype.renderStack = function(r) {
    return z(this, void 0, void 0, function() {
      var t;
      return N(this, function(B) {
        switch (B.label) {
          case 0:
            return t = r.element.container.styles, t.isVisible() ? [4, this.renderStackContent(r)] : [3, 2];
          case 1:
            B.sent(), B.label = 2;
          case 2:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, e.prototype.renderNode = function(r) {
    return z(this, void 0, void 0, function() {
      return N(this, function(t) {
        switch (t.label) {
          case 0:
            if (T(
              r.container.flags,
              16
              /* DEBUG_RENDER */
            ))
              debugger;
            return r.container.styles.isVisible() ? [4, this.renderNodeBackgroundAndBorders(r)] : [3, 3];
          case 1:
            return t.sent(), [4, this.renderNodeContent(r)];
          case 2:
            t.sent(), t.label = 3;
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, e.prototype.renderTextWithLetterSpacing = function(r, t, B) {
    var n = this;
    if (t === 0)
      this.ctx.fillText(r.text, r.bounds.left, r.bounds.top + B);
    else {
      var s = Ar(r.text);
      s.reduce(function(o, i) {
        return n.ctx.fillText(i, o, r.bounds.top + B), o + n.ctx.measureText(i).width;
      }, r.bounds.left);
    }
  }, e.prototype.createFontStyle = function(r) {
    var t = r.fontVariant.filter(function(s) {
      return s === "normal" || s === "small-caps";
    }).join(""), B = pa(r.fontFamily).join(", "), n = ne(r.fontSize) ? "" + r.fontSize.number + r.fontSize.unit : r.fontSize.number + "px";
    return [
      [r.fontStyle, t, r.fontWeight, n, B].join(" "),
      B,
      n
    ];
  }, e.prototype.renderTextNode = function(r, t) {
    return z(this, void 0, void 0, function() {
      var B, n, s, o, i, Q, a, c, g = this;
      return N(this, function(U) {
        return B = this.createFontStyle(t), n = B[0], s = B[1], o = B[2], this.ctx.font = n, this.ctx.direction = t.direction === 1 ? "rtl" : "ltr", this.ctx.textAlign = "left", this.ctx.textBaseline = "alphabetic", i = this.fontMetrics.getMetrics(s, o), Q = i.baseline, a = i.middle, c = t.paintOrder, r.textBounds.forEach(function(w) {
          c.forEach(function(C) {
            switch (C) {
              case 0:
                g.ctx.fillStyle = V(t.color), g.renderTextWithLetterSpacing(w, t.letterSpacing, Q);
                var I = t.textShadow;
                I.length && w.text.trim().length && (I.slice(0).reverse().forEach(function(h) {
                  g.ctx.shadowColor = V(h.color), g.ctx.shadowOffsetX = h.offsetX.number * g.options.scale, g.ctx.shadowOffsetY = h.offsetY.number * g.options.scale, g.ctx.shadowBlur = h.blur.number, g.renderTextWithLetterSpacing(w, t.letterSpacing, Q);
                }), g.ctx.shadowColor = "", g.ctx.shadowOffsetX = 0, g.ctx.shadowOffsetY = 0, g.ctx.shadowBlur = 0), t.textDecorationLine.length && (g.ctx.fillStyle = V(t.textDecorationColor || t.color), t.textDecorationLine.forEach(function(h) {
                  switch (h) {
                    case 1:
                      g.ctx.fillRect(w.bounds.left, Math.round(w.bounds.top + Q), w.bounds.width, 1);
                      break;
                    case 2:
                      g.ctx.fillRect(w.bounds.left, Math.round(w.bounds.top), w.bounds.width, 1);
                      break;
                    case 3:
                      g.ctx.fillRect(w.bounds.left, Math.ceil(w.bounds.top + a), w.bounds.width, 1);
                      break;
                  }
                }));
                break;
              case 1:
                t.webkitTextStrokeWidth && w.text.trim().length && (g.ctx.strokeStyle = V(t.webkitTextStrokeColor), g.ctx.lineWidth = t.webkitTextStrokeWidth, g.ctx.lineJoin = window.chrome ? "miter" : "round", g.ctx.strokeText(w.text, w.bounds.left, w.bounds.top + Q)), g.ctx.strokeStyle = "", g.ctx.lineWidth = 0, g.ctx.lineJoin = "miter";
                break;
            }
          });
        }), [
          2
          /*return*/
        ];
      });
    });
  }, e.prototype.renderReplacedElement = function(r, t, B) {
    if (B && r.intrinsicWidth > 0 && r.intrinsicHeight > 0) {
      var n = Je(r), s = Pe(t);
      this.path(s), this.ctx.save(), this.ctx.clip(), this.ctx.drawImage(B, 0, 0, r.intrinsicWidth, r.intrinsicHeight, n.left, n.top, n.width, n.height), this.ctx.restore();
    }
  }, e.prototype.renderNodeContent = function(r) {
    return z(this, void 0, void 0, function() {
      var t, B, n, s, o, i, d, d, Q, a, c, g, y, U, w, f, C, I, h, d, L, y, f;
      return N(this, function(l) {
        switch (l.label) {
          case 0:
            this.applyEffects(r.getEffects(
              4
              /* CONTENT */
            )), t = r.container, B = r.curves, n = t.styles, s = 0, o = t.textNodes, l.label = 1;
          case 1:
            return s < o.length ? (i = o[s], [4, this.renderTextNode(i, n)]) : [3, 4];
          case 2:
            l.sent(), l.label = 3;
          case 3:
            return s++, [3, 1];
          case 4:
            if (!(t instanceof OB)) return [3, 8];
            l.label = 5;
          case 5:
            return l.trys.push([5, 7, , 8]), [4, this.context.cache.match(t.src)];
          case 6:
            return d = l.sent(), this.renderReplacedElement(t, B, d), [3, 8];
          case 7:
            return l.sent(), this.context.logger.error("Error loading image " + t.src), [3, 8];
          case 8:
            if (t instanceof VB && this.renderReplacedElement(t, B, t.canvas), !(t instanceof kB)) return [3, 12];
            l.label = 9;
          case 9:
            return l.trys.push([9, 11, , 12]), [4, this.context.cache.match(t.svg)];
          case 10:
            return d = l.sent(), this.renderReplacedElement(t, B, d), [3, 12];
          case 11:
            return l.sent(), this.context.logger.error("Error loading svg " + t.svg.substring(0, 255)), [3, 12];
          case 12:
            return t instanceof XB && t.tree ? (Q = new e(this.context, {
              scale: this.options.scale,
              backgroundColor: t.backgroundColor,
              x: 0,
              y: 0,
              width: t.width,
              height: t.height
            }), [4, Q.render(t.tree)]) : [3, 14];
          case 13:
            a = l.sent(), t.width && t.height && this.ctx.drawImage(a, 0, 0, t.width, t.height, t.bounds.left, t.bounds.top, t.bounds.width, t.bounds.height), l.label = 14;
          case 14:
            if (t instanceof er && (c = Math.min(t.bounds.width, t.bounds.height), t.type === Ve ? t.checked && (this.ctx.save(), this.path([
              new u(t.bounds.left + c * 0.39363, t.bounds.top + c * 0.79),
              new u(t.bounds.left + c * 0.16, t.bounds.top + c * 0.5549),
              new u(t.bounds.left + c * 0.27347, t.bounds.top + c * 0.44071),
              new u(t.bounds.left + c * 0.39694, t.bounds.top + c * 0.5649),
              new u(t.bounds.left + c * 0.72983, t.bounds.top + c * 0.23),
              new u(t.bounds.left + c * 0.84, t.bounds.top + c * 0.34085),
              new u(t.bounds.left + c * 0.39363, t.bounds.top + c * 0.79)
            ]), this.ctx.fillStyle = V(Xr), this.ctx.fill(), this.ctx.restore()) : t.type === ke && t.checked && (this.ctx.save(), this.ctx.beginPath(), this.ctx.arc(t.bounds.left + c / 2, t.bounds.top + c / 2, c / 4, 0, Math.PI * 2, !0), this.ctx.fillStyle = V(Xr), this.ctx.fill(), this.ctx.restore())), ha(t) && t.value.length) {
              switch (g = this.createFontStyle(n), y = g[0], U = g[1], w = this.fontMetrics.getMetrics(y, U).baseline, this.ctx.font = y, this.ctx.fillStyle = V(n.color), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = fa(t.styles.textAlign), f = Je(t), C = 0, t.styles.textAlign) {
                case 1:
                  C += f.width / 2;
                  break;
                case 2:
                  C += f.width;
                  break;
              }
              I = f.add(C, 0, 0, -f.height / 2 + 1), this.ctx.save(), this.path([
                new u(f.left, f.top),
                new u(f.left + f.width, f.top),
                new u(f.left + f.width, f.top + f.height),
                new u(f.left, f.top + f.height)
              ]), this.ctx.clip(), this.renderTextWithLetterSpacing(new Ae(t.value, I), n.letterSpacing, w), this.ctx.restore(), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = "left";
            }
            if (!T(
              t.styles.display,
              2048
              /* LIST_ITEM */
            )) return [3, 20];
            if (t.styles.listStyleImage === null) return [3, 19];
            if (h = t.styles.listStyleImage, h.type !== 0) return [3, 18];
            d = void 0, L = h.url, l.label = 15;
          case 15:
            return l.trys.push([15, 17, , 18]), [4, this.context.cache.match(L)];
          case 16:
            return d = l.sent(), this.ctx.drawImage(d, t.bounds.left - (d.width + 10), t.bounds.top), [3, 18];
          case 17:
            return l.sent(), this.context.logger.error("Error loading list-style-image " + L), [3, 18];
          case 18:
            return [3, 20];
          case 19:
            r.listValue && t.styles.listStyleType !== -1 && (y = this.createFontStyle(n)[0], this.ctx.font = y, this.ctx.fillStyle = V(n.color), this.ctx.textBaseline = "middle", this.ctx.textAlign = "right", f = new pA(t.bounds.left, t.bounds.top + b(t.styles.paddingTop, t.bounds.width), t.bounds.width, Kr(n.lineHeight, n.fontSize.number) / 2 + 1), this.renderTextWithLetterSpacing(new Ae(r.listValue, f), n.letterSpacing, Kr(n.lineHeight, n.fontSize.number) / 2 + 2), this.ctx.textBaseline = "bottom", this.ctx.textAlign = "left"), l.label = 20;
          case 20:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, e.prototype.renderStackContent = function(r) {
    return z(this, void 0, void 0, function() {
      var t, B, h, n, s, h, o, i, h, Q, a, h, c, g, h, U, w, h, C, I, h;
      return N(this, function(d) {
        switch (d.label) {
          case 0:
            if (T(
              r.element.container.flags,
              16
              /* DEBUG_RENDER */
            ))
              debugger;
            return [4, this.renderNodeBackgroundAndBorders(r.element)];
          case 1:
            d.sent(), t = 0, B = r.negativeZIndex, d.label = 2;
          case 2:
            return t < B.length ? (h = B[t], [4, this.renderStack(h)]) : [3, 5];
          case 3:
            d.sent(), d.label = 4;
          case 4:
            return t++, [3, 2];
          case 5:
            return [4, this.renderNodeContent(r.element)];
          case 6:
            d.sent(), n = 0, s = r.nonInlineLevel, d.label = 7;
          case 7:
            return n < s.length ? (h = s[n], [4, this.renderNode(h)]) : [3, 10];
          case 8:
            d.sent(), d.label = 9;
          case 9:
            return n++, [3, 7];
          case 10:
            o = 0, i = r.nonPositionedFloats, d.label = 11;
          case 11:
            return o < i.length ? (h = i[o], [4, this.renderStack(h)]) : [3, 14];
          case 12:
            d.sent(), d.label = 13;
          case 13:
            return o++, [3, 11];
          case 14:
            Q = 0, a = r.nonPositionedInlineLevel, d.label = 15;
          case 15:
            return Q < a.length ? (h = a[Q], [4, this.renderStack(h)]) : [3, 18];
          case 16:
            d.sent(), d.label = 17;
          case 17:
            return Q++, [3, 15];
          case 18:
            c = 0, g = r.inlineLevel, d.label = 19;
          case 19:
            return c < g.length ? (h = g[c], [4, this.renderNode(h)]) : [3, 22];
          case 20:
            d.sent(), d.label = 21;
          case 21:
            return c++, [3, 19];
          case 22:
            U = 0, w = r.zeroOrAutoZIndexOrTransformedOrOpacity, d.label = 23;
          case 23:
            return U < w.length ? (h = w[U], [4, this.renderStack(h)]) : [3, 26];
          case 24:
            d.sent(), d.label = 25;
          case 25:
            return U++, [3, 23];
          case 26:
            C = 0, I = r.positiveZIndex, d.label = 27;
          case 27:
            return C < I.length ? (h = I[C], [4, this.renderStack(h)]) : [3, 30];
          case 28:
            d.sent(), d.label = 29;
          case 29:
            return C++, [3, 27];
          case 30:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, e.prototype.mask = function(r) {
    this.ctx.beginPath(), this.ctx.moveTo(0, 0), this.ctx.lineTo(this.canvas.width, 0), this.ctx.lineTo(this.canvas.width, this.canvas.height), this.ctx.lineTo(0, this.canvas.height), this.ctx.lineTo(0, 0), this.formatPath(r.slice(0).reverse()), this.ctx.closePath();
  }, e.prototype.path = function(r) {
    this.ctx.beginPath(), this.formatPath(r), this.ctx.closePath();
  }, e.prototype.formatPath = function(r) {
    var t = this;
    r.forEach(function(B, n) {
      var s = q(B) ? B.start : B;
      n === 0 ? t.ctx.moveTo(s.x, s.y) : t.ctx.lineTo(s.x, s.y), q(B) && t.ctx.bezierCurveTo(B.startControl.x, B.startControl.y, B.endControl.x, B.endControl.y, B.end.x, B.end.y);
    });
  }, e.prototype.renderRepeat = function(r, t, B, n) {
    this.path(r), this.ctx.fillStyle = t, this.ctx.translate(B, n), this.ctx.fill(), this.ctx.translate(-B, -n);
  }, e.prototype.resizeImage = function(r, t, B) {
    var n;
    if (r.width === t && r.height === B)
      return r;
    var s = (n = this.canvas.ownerDocument) !== null && n !== void 0 ? n : document, o = s.createElement("canvas");
    o.width = Math.max(1, t), o.height = Math.max(1, B);
    var i = o.getContext("2d");
    return i.drawImage(r, 0, 0, r.width, r.height, 0, 0, t, B), o;
  }, e.prototype.renderBackgroundImage = function(r) {
    return z(this, void 0, void 0, function() {
      var t, B, n, s, o, i;
      return N(this, function(Q) {
        switch (Q.label) {
          case 0:
            t = r.styles.backgroundImage.length - 1, B = function(a) {
              var c, g, U, G, O, X, m, R, p, w, G, O, X, m, R, C, I, h, d, L, y, f, l, E, p, H, G, sA, Z, m, R, AA, O, X, et, EA, se, tt, rt, TA, Bt, nt;
              return N(this, function(IA) {
                switch (IA.label) {
                  case 0:
                    if (a.type !== 0) return [3, 5];
                    c = void 0, g = a.url, IA.label = 1;
                  case 1:
                    return IA.trys.push([1, 3, , 4]), [4, n.context.cache.match(g)];
                  case 2:
                    return c = IA.sent(), [3, 4];
                  case 3:
                    return IA.sent(), n.context.logger.error("Error loading background-image " + g), [3, 4];
                  case 4:
                    return c && (U = It(r, t, [
                      c.width,
                      c.height,
                      c.width / c.height
                    ]), G = U[0], O = U[1], X = U[2], m = U[3], R = U[4], p = n.ctx.createPattern(n.resizeImage(c, m, R), "repeat"), n.renderRepeat(G, p, O, X)), [3, 6];
                  case 5:
                    fo(a) ? (w = It(r, t, [null, null, null]), G = w[0], O = w[1], X = w[2], m = w[3], R = w[4], C = uo(a.angle, m, R), I = C[0], h = C[1], d = C[2], L = C[3], y = C[4], f = document.createElement("canvas"), f.width = m, f.height = R, l = f.getContext("2d"), E = l.createLinearGradient(h, L, d, y), Ir(a.stops, I).forEach(function(OA) {
                      return E.addColorStop(OA.stop, V(OA.color));
                    }), l.fillStyle = E, l.fillRect(0, 0, m, R), m > 0 && R > 0 && (p = n.ctx.createPattern(f, "repeat"), n.renderRepeat(G, p, O, X))) : Ho(a) && (H = It(r, t, [
                      null,
                      null,
                      null
                    ]), G = H[0], sA = H[1], Z = H[2], m = H[3], R = H[4], AA = a.position.length === 0 ? [qt] : a.position, O = b(AA[0], m), X = b(AA[AA.length - 1], R), et = Co(a, O, X, m, R), EA = et[0], se = et[1], EA > 0 && se > 0 && (tt = n.ctx.createRadialGradient(sA + O, Z + X, 0, sA + O, Z + X, EA), Ir(a.stops, EA * 2).forEach(function(OA) {
                      return tt.addColorStop(OA.stop, V(OA.color));
                    }), n.path(G), n.ctx.fillStyle = tt, EA !== se ? (rt = r.bounds.left + 0.5 * r.bounds.width, TA = r.bounds.top + 0.5 * r.bounds.height, Bt = se / EA, nt = 1 / Bt, n.ctx.save(), n.ctx.translate(rt, TA), n.ctx.transform(1, 0, 0, Bt, 0, 0), n.ctx.translate(-rt, -TA), n.ctx.fillRect(sA, nt * (Z - TA) + TA, m, R * nt), n.ctx.restore()) : n.ctx.fill())), IA.label = 6;
                  case 6:
                    return t--, [
                      2
                      /*return*/
                    ];
                }
              });
            }, n = this, s = 0, o = r.styles.backgroundImage.slice(0).reverse(), Q.label = 1;
          case 1:
            return s < o.length ? (i = o[s], [5, B(i)]) : [3, 4];
          case 2:
            Q.sent(), Q.label = 3;
          case 3:
            return s++, [3, 1];
          case 4:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, e.prototype.renderSolidBorder = function(r, t, B) {
    return z(this, void 0, void 0, function() {
      return N(this, function(n) {
        return this.path(jr(B, t)), this.ctx.fillStyle = V(r), this.ctx.fill(), [
          2
          /*return*/
        ];
      });
    });
  }, e.prototype.renderDoubleBorder = function(r, t, B, n) {
    return z(this, void 0, void 0, function() {
      var s, o;
      return N(this, function(i) {
        switch (i.label) {
          case 0:
            return t < 3 ? [4, this.renderSolidBorder(r, B, n)] : [3, 2];
          case 1:
            return i.sent(), [
              2
              /*return*/
            ];
          case 2:
            return s = Qa(n, B), this.path(s), this.ctx.fillStyle = V(r), this.ctx.fill(), o = aa(n, B), this.path(o), this.ctx.fill(), [
              2
              /*return*/
            ];
        }
      });
    });
  }, e.prototype.renderNodeBackgroundAndBorders = function(r) {
    return z(this, void 0, void 0, function() {
      var t, B, n, s, o, i, Q, a, c = this;
      return N(this, function(g) {
        switch (g.label) {
          case 0:
            return this.applyEffects(r.getEffects(
              2
              /* BACKGROUND_BORDERS */
            )), t = r.container.styles, B = !SA(t.backgroundColor) || t.backgroundImage.length, n = [
              { style: t.borderTopStyle, color: t.borderTopColor, width: t.borderTopWidth },
              { style: t.borderRightStyle, color: t.borderRightColor, width: t.borderRightWidth },
              { style: t.borderBottomStyle, color: t.borderBottomColor, width: t.borderBottomWidth },
              { style: t.borderLeftStyle, color: t.borderLeftColor, width: t.borderLeftWidth }
            ], s = da(MA(t.backgroundClip, 0), r.curves), B || t.boxShadow.length ? (this.ctx.save(), this.path(s), this.ctx.clip(), SA(t.backgroundColor) || (this.ctx.fillStyle = V(t.backgroundColor), this.ctx.fill()), [4, this.renderBackgroundImage(r.container)]) : [3, 2];
          case 1:
            g.sent(), this.ctx.restore(), t.boxShadow.slice(0).reverse().forEach(function(U) {
              c.ctx.save();
              var w = Re(r.curves), C = U.inset ? 0 : Fa, I = oa(w, -C + (U.inset ? 1 : -1) * U.spread.number, (U.inset ? 1 : -1) * U.spread.number, U.spread.number * (U.inset ? -2 : 2), U.spread.number * (U.inset ? -2 : 2));
              U.inset ? (c.path(w), c.ctx.clip(), c.mask(I)) : (c.mask(w), c.ctx.clip(), c.path(I)), c.ctx.shadowOffsetX = U.offsetX.number + C, c.ctx.shadowOffsetY = U.offsetY.number, c.ctx.shadowColor = V(U.color), c.ctx.shadowBlur = U.blur.number, c.ctx.fillStyle = U.inset ? V(U.color) : "rgba(0,0,0,1)", c.ctx.fill(), c.ctx.restore();
            }), g.label = 2;
          case 2:
            o = 0, i = 0, Q = n, g.label = 3;
          case 3:
            return i < Q.length ? (a = Q[i], a.style !== 0 && !SA(a.color) && a.width > 0 ? a.style !== 2 ? [3, 5] : [4, this.renderDashedDottedBorder(
              a.color,
              a.width,
              o,
              r.curves,
              2
              /* DASHED */
            )] : [3, 11]) : [3, 13];
          case 4:
            return g.sent(), [3, 11];
          case 5:
            return a.style !== 3 ? [3, 7] : [4, this.renderDashedDottedBorder(
              a.color,
              a.width,
              o,
              r.curves,
              3
              /* DOTTED */
            )];
          case 6:
            return g.sent(), [3, 11];
          case 7:
            return a.style !== 4 ? [3, 9] : [4, this.renderDoubleBorder(a.color, a.width, o, r.curves)];
          case 8:
            return g.sent(), [3, 11];
          case 9:
            return [4, this.renderSolidBorder(a.color, o, r.curves)];
          case 10:
            g.sent(), g.label = 11;
          case 11:
            o++, g.label = 12;
          case 12:
            return i++, [3, 3];
          case 13:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, e.prototype.renderDashedDottedBorder = function(r, t, B, n, s) {
    return z(this, void 0, void 0, function() {
      var o, i, Q, a, c, g, U, w, C, I, h, d, L, y, f, l, f, l;
      return N(this, function(E) {
        return this.ctx.save(), o = ca(n, B), i = jr(n, B), s === 2 && (this.path(i), this.ctx.clip()), q(i[0]) ? (Q = i[0].start.x, a = i[0].start.y) : (Q = i[0].x, a = i[0].y), q(i[1]) ? (c = i[1].end.x, g = i[1].end.y) : (c = i[1].x, g = i[1].y), B === 0 || B === 2 ? U = Math.abs(Q - c) : U = Math.abs(a - g), this.ctx.beginPath(), s === 3 ? this.formatPath(o) : this.formatPath(i.slice(0, 2)), w = t < 3 ? t * 3 : t * 2, C = t < 3 ? t * 2 : t, s === 3 && (w = t, C = t), I = !0, U <= w * 2 ? I = !1 : U <= w * 2 + C ? (h = U / (2 * w + C), w *= h, C *= h) : (d = Math.floor((U + C) / (w + C)), L = (U - d * w) / (d - 1), y = (U - (d + 1) * w) / d, C = y <= 0 || Math.abs(C - L) < Math.abs(C - y) ? L : y), I && (s === 3 ? this.ctx.setLineDash([0, w + C]) : this.ctx.setLineDash([w, C])), s === 3 ? (this.ctx.lineCap = "round", this.ctx.lineWidth = t) : this.ctx.lineWidth = t * 2 + 1.1, this.ctx.strokeStyle = V(r), this.ctx.stroke(), this.ctx.setLineDash([]), s === 2 && (q(i[0]) && (f = i[3], l = i[0], this.ctx.beginPath(), this.formatPath([new u(f.end.x, f.end.y), new u(l.start.x, l.start.y)]), this.ctx.stroke()), q(i[1]) && (f = i[1], l = i[2], this.ctx.beginPath(), this.formatPath([new u(f.end.x, f.end.y), new u(l.start.x, l.start.y)]), this.ctx.stroke())), this.ctx.restore(), [
          2
          /*return*/
        ];
      });
    });
  }, e.prototype.render = function(r) {
    return z(this, void 0, void 0, function() {
      var t;
      return N(this, function(B) {
        switch (B.label) {
          case 0:
            return this.options.backgroundColor && (this.ctx.fillStyle = V(this.options.backgroundColor), this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height)), t = ia(r), [4, this.renderStack(t)];
          case 1:
            return B.sent(), this.applyEffects([]), [2, this.canvas];
        }
      });
    });
  }, e;
})(tn);
var ha = function(A) {
  return A instanceof JB || A instanceof PB ? !0 : A instanceof er && A.type !== ke && A.type !== Ve;
}, da = function(A, e) {
  switch (A) {
    case 0:
      return Re(e);
    case 2:
      return ta(e);
    case 1:
    default:
      return Pe(e);
  }
}, fa = function(A) {
  switch (A) {
    case 1:
      return "center";
    case 2:
      return "right";
    case 0:
    default:
      return "left";
  }
}, Ha = ["-apple-system", "system-ui"], pa = function(A) {
  return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? A.filter(function(e) {
    return Ha.indexOf(e) === -1;
  }) : A;
};
(function(A) {
  tA(e, A);
  function e(r, t) {
    var B = A.call(this, r, t) || this;
    return B.canvas = t.canvas ? t.canvas : document.createElement("canvas"), B.ctx = B.canvas.getContext("2d"), B.options = t, B.canvas.width = Math.floor(t.width * t.scale), B.canvas.height = Math.floor(t.height * t.scale), B.canvas.style.width = t.width + "px", B.canvas.style.height = t.height + "px", B.ctx.scale(B.options.scale, B.options.scale), B.ctx.translate(-t.x, -t.y), B.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + t.width + "x" + t.height + " at " + t.x + "," + t.y + ") with scale " + t.scale), B;
  }
  return e.prototype.render = function(r) {
    return z(this, void 0, void 0, function() {
      var t, B;
      return N(this, function(n) {
        switch (n.label) {
          case 0:
            return t = Pt(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, r), [4, Ea(t)];
          case 1:
            return B = n.sent(), this.options.backgroundColor && (this.ctx.fillStyle = V(this.options.backgroundColor), this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale)), this.ctx.drawImage(B, -this.options.x * this.options.scale, -this.options.y * this.options.scale), [2, this.canvas];
        }
      });
    });
  }, e;
})(tn);
var Ea = function(A) {
  return new Promise(function(e, r) {
    var t = new Image();
    t.onload = function() {
      e(t);
    }, t.onerror = r, t.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(A));
  });
};
typeof window < "u" && Aa.setContext(window);
function Ia(A, e = 100, r) {
  let t;
  return function(...B) {
    if (t) return;
    const n = this;
    t = window.setTimeout(function() {
      t = void 0, A.apply(n, B);
    }, e);
  };
}
const ya = Nt({
  name: "JtAutoHeightWrapper",
  inheritAttrs: !0
}), Ka = /* @__PURE__ */ Nt({
  ...ya,
  props: {
    minHeight: { default: 300 },
    throttleMs: { default: 500 }
  },
  setup(A) {
    const e = A, r = xe(e.minHeight), t = xe(e.throttleMs), B = () => {
      var i;
      const o = ((i = s.value) == null ? void 0 : i.clientHeight) ?? 0;
      r.value = o < e.minHeight ? e.minHeight : o;
    }, n = Ia(() => {
      B();
    }, t.value), { el: s } = pn(n);
    return _t(() => {
      AB(() => {
        B();
      });
    }), (o, i) => (JA(), XA("div", {
      ref_key: "el",
      ref: s,
      class: "jt-auto-height-wrapper"
    }, [
      eB(o.$slots, "default", { height: r.value }, void 0, !0)
    ], 512));
  }
}), rn = (A, e) => {
  const r = A.__vccOpts || A;
  for (const [t, B] of e)
    r[t] = B;
  return r;
}, ma = /* @__PURE__ */ rn(Ka, [["__scopeId", "data-v-c074c935"]]), La = rB(ma), yt = Math.PI / 2, ba = 5;
function Da(A) {
  function e() {
    const r = A.value;
    if (Array.isArray(r)) {
      const t = Math.floor(Math.random() * r.length);
      return r[t];
    }
    return r;
  }
  return {
    randomColor: e
  };
}
function va() {
  const A = xe(), e = tB({
    w: 0,
    h: 0
  }), r = QA(() => e.w / 2), t = QA(() => e.h / 2), B = QA(() => Math.atan(e.h / e.w));
  return _t(function() {
    var n, s;
    AB(() => {
      var o, i;
      e.w = ((o = A.value) == null ? void 0 : o.clientWidth) || 0, e.h = ((i = A.value) == null ? void 0 : i.clientHeight) || 0;
    }), e.w = ((n = A.value) == null ? void 0 : n.clientWidth) || 0, e.h = ((s = A.value) == null ? void 0 : s.clientHeight) || 0;
  }), {
    containerEl: A,
    containerSize: e,
    containerHalfW: r,
    containerHalfH: t,
    containerSplitAngle: B
  };
}
function Ma(A, e, r) {
  const t = QA(function() {
    return [1, ...A.value.slice(0, ba)];
  }), B = QA(function() {
    const Q = t.value, a = Q.length, c = new Array(a).fill(0);
    for (let g = 0; g < a; g++) {
      let U = 0;
      for (let w = 0; w < g + 1; w++)
        U += Q[w];
      c[g] = U;
    }
    return c;
  }), n = QA(() => B.value[B.value.length - 1] ?? 0), s = QA(() => Math.PI * 2 / e.value), o = QA(() => r.value ?? 360 / e.value), i = QA(() => o.value / 360 * Math.PI * 2);
  return { levelsPreSum: B, itemMaxCount: n, axisPerRadius: s, randomRadiusPerAxis: i };
}
function xa(A, e) {
  let r = Math.abs(A);
  r > Math.PI && (r = r % Math.PI);
  const { halfW: t, halfH: B, splitAngle: n } = e;
  let s = t;
  return r === 0 ? s = t : r < n ? s = t / Math.cos(r) : r < yt ? s = B / Math.cos(yt - r) : r < Math.PI - n ? s = B / Math.cos(r - yt) : r < Math.PI ? s = t / Math.cos(Math.PI - r) : s = t, s;
}
function Sa(A, e, r, t, B, n, s) {
  const o = tB([]), { randomColor: i } = Da(A), { containerEl: Q, containerHalfW: a, containerHalfH: c, containerSplitAngle: g } = va(), { levelsPreSum: U, itemMaxCount: w, axisPerRadius: C, randomRadiusPerAxis: I } = Ma(
    e,
    r,
    t
  );
  let h = 0;
  function d() {
    return B.value ? Math.floor(Math.random() * r.value) : h++ % r.value;
  }
  function L(f) {
    const l = Math.random() * I.value * 2 - I.value, E = d(), p = C.value * E + l, H = xa(p, {
      halfW: a.value,
      halfH: c.value,
      splitAngle: g.value
    }), G = Object.assign(f, {
      level: -1,
      color: i(),
      _w: sn({
        xWeight: Math.cos(p),
        yWeight: Math.sin(p),
        directionLength: H
      })
    });
    for (o.push(G); o.length > w.value; )
      o.shift();
  }
  function y(f, l) {
    const E = o.length - l - 1;
    let p = 0;
    const H = Math.sqrt(w.value * E);
    p = ((Math.sqrt(w.value * (E + 1)) - H) * Math.random() + H) / w.value * f._w.directionLength;
    let Z = 1, m = 1;
    const R = U.value.length;
    for (let O = 0; O < R; O++) {
      const X = U.value[O];
      if (E < X) {
        f.level = E, Z = 1 - n.value * O, m = 1 - s.value * O;
        break;
      }
    }
    const AA = {};
    if (E === 0)
      AA.transform = "translate(-50%, -50%)", AA.animation = "fadeIn ease 1s";
    else {
      const O = p * f._w.xWeight, X = p * f._w.yWeight;
      AA.transform = `translate(calc(-50% - ${O}px), calc(-50% - ${X}px)) scale(${Z})`;
    }
    return AA.color = f.color, AA.opacity = m, AA;
  }
  return {
    containerEl: Q,
    datas: o,
    append: L,
    itemStyle: y
  };
}
const Ga = { class: "word" }, Ta = {
  key: 1,
  class: "default"
}, Oa = /* @__PURE__ */ Nt({
  name: "WordCloudTunnel",
  inheritAttrs: !1,
  __name: "WordCloudTunnel",
  props: {
    color: { default: "#000" },
    fontSize: { default: "32px" },
    deeps: { default: () => [6, 6, 12] },
    axisCount: { default: 6 },
    randomAngleRangePerAxis: {},
    randomAxis: { type: Boolean, default: !0 },
    scaleStep: { default: 0.1 },
    opacityStep: { default: 0.2 },
    animationDuration: { default: 1e3 }
  },
  setup(A, { expose: e }) {
    const r = A, {
      color: t,
      fontSize: B,
      deeps: n,
      axisCount: s,
      randomAngleRangePerAxis: o,
      randomAxis: i,
      scaleStep: Q,
      opacityStep: a
    } = on(r), { containerEl: c, datas: g, append: U, itemStyle: w } = Sa(
      t,
      n,
      s,
      o,
      i,
      Q,
      a
    );
    return e({
      append: U
    }), (C, I) => (JA(), XA("div", {
      ref_key: "containerEl",
      ref: c,
      class: "jt-word-cloud-tunnel",
      style: rr({
        "--wct-default-size": st(B),
        "--wct-animation-duration": `${C.animationDuration}ms`
      })
    }, [
      (JA(!0), XA(Qn, null, an(st(g), (h, d) => (JA(), XA("div", {
        key: h.id,
        class: "word-item",
        style: rr(st(w)(h, d))
      }, [
        cn("div", Ga, [
          C.$slots.default ? eB(C.$slots, "default", gn({
            key: 0,
            ref_for: !0
          }, h), void 0, !0) : (JA(), XA("div", Ta, wn(h.text), 1))
        ])
      ], 4))), 128))
    ], 4));
  }
}), Va = /* @__PURE__ */ rn(Oa, [["__scopeId", "data-v-8668e0b8"]]), ka = rB(Va), Ra = [La, ka], Bn = function(A) {
  Ra.forEach((e) => {
    e.name && A.component(e.name, e);
  });
};
typeof window < "u" && window.Vue && Bn(window.Vue);
const Ja = { install: Bn };
export {
  La as JtAutoHeightWrapper,
  ka as JtWordCloudTunnel,
  Ja as default,
  rB as withInstall
};
//# sourceMappingURL=vue-components.js.map
